export default [
  {
    id: "DistrictPoly_area",
    type: "line",
    source: "5ec4d27c8c861c736024026f",
    "source-layer": "DistrictPoly",
    filter: ["all"],
    layout: { visibility: "visible" },
    paint: {
      "line-blur": 1,
      "line-color": "rgba(68, 67, 65, 0.5)",
      "line-dasharray": [4, 1.2],
      "line-width": {
        stops: [
          [6, 2.5],
          [10, 1.5],
          [15, 0.7],
        ],
      },
    },
  },
  {
    id: "Building_box",
    type: "fill",
    source: "5ec4d27c8c861c736024026f",
    "source-layer": "Building",
    layout: { visibility: "visible" },
    paint: {
      "fill-antialias": true,
      "fill-color": "rgba(237, 225, 225, 0)",
      "fill-outline-color": "rgba(23, 22, 22, 0.23)",
      "fill-opacity": 0.2,
    },
  },
  {
    id: "Building_line",
    type: "line",
    source: "5ec4d27c8c861c736024026f",
    "source-layer": "BuildingLine",
    layout: { visibility: "visible" },
    paint: {
      "line-blur": 0,
      "line-color": "rgba(247, 243, 243, 0.52)",
      "line-width": {
        stops: [
          [10, 2],
          [20, 4],
        ],
      },
    },
  },
  {
    id: "Centerline",
    type: "line",
    source: "5ec4d27c8c861c736024026f",
    "source-layer": "Centerline",
    filter: ["all"],
    layout: {
      "line-cap": "round",
      "line-join": "round",
      visibility: "visible",
    },
    paint: {
      "line-blur": 1,
      "line-color": "rgba(16, 16, 16, 0.62)",
      "line-dasharray": [1],
      "line-width": 2,
    },
  },
  {
    id: "Hydrology",
    type: "line",
    source: "5ec4d27c8c861c736024026f",
    "source-layer": "Hydrology",
    filter: ["all"],
    layout: { visibility: "visible" },
    paint: {
      "line-blur": 1,
      "line-color": "rgba(45, 45, 45, 0.23)",
      "line-dasharray": [1, 0],
      "line-width": 2,
    },
  },
  {
    id: "Landmark_line",
    type: "line",
    source: "5ec4d27c8c861c736024026f",
    "source-layer": "Landmarkline",
    layout: { visibility: "visible" },
    paint: {
      "line-blur": 1,
      "line-color": "rgba(23, 22, 22, 0.23)",
      "line-dasharray": [1, 2],
      "line-width": {
        stops: [
          [10, 1],
          [15, 1],
          [20, 2],
        ],
      },
    },
  },
  {
    id: "RoadEdge",
    type: "line",
    source: "5ec4d27c8c861c736024026f",
    "source-layer": "RoadEdge",
    filter: ["all"],
    layout: {
      "line-cap": "round",
      "line-join": "round",
      visibility: "visible",
    },
    paint: {
      "line-blur": 1,
      "line-color": "rgba(30, 29, 30, 0.87)",
      "line-dasharray": [4, 2],
      "line-width": 1.5,
      "line-translate": [0, 0],
    },
  },
  {
    id: "DistrictPoly_lable",
    type: "symbol",
    source: "5ec4d27c8c861c736024026f",
    "source-layer": "DistrictPoly",
    maxzoom: 15,
    layout: {
      "icon-anchor": "center",
      "symbol-avoid-edges": true,
      "symbol-placement": "point",
      "symbol-spacing": 250,
      "symbol-z-order": "auto",
      "text-field": "{name_t}",
      "text-font": ["Kanit"],
      "text-max-width": 8,
      "text-pitch-alignment": "auto",
      "text-rotation-alignment": "auto",
      "text-size": {
        stops: [
          [10, 10],
          [15, 12],
          [20, 14],
        ],
      },
      visibility: "visible",
    },
    paint: {
      "icon-color": "rgba(251, 249, 248, 1)",
      "icon-halo-color": "rgba(253, 248, 248, 1)",
      "icon-halo-width": 0,
      "text-color": "rgba(61, 60, 58, 0.83)",
      "text-halo-blur": 1,
      "text-halo-color": "rgba(251, 246, 246, 0.69)",
      "text-halo-width": 3,
      "text-translate-anchor": "map",
    },
  },
  {
    id: "DistrictPoly_txt",
    type: "symbol",
    source: "5ec4d27c8c861c736024026f",
    "source-layer": "DistrictPoly",
    layout: {
      "symbol-placement": "line",
      "text-field": "MEA",
      "text-font": ["Kanit"],
      "text-size": 11,
      visibility: "visible",
    },
    paint: {
      "icon-color": "rgba(251, 249, 248, 1)",
      "icon-halo-color": "rgba(253, 248, 248, 1)",
      "icon-halo-width": 0,
      "text-color": "rgba(23, 22, 22, 0.23)",
      "text-halo-blur": 1,
      "text-halo-color": "rgba(251, 246, 246, 0.69)",
      "text-halo-width": 3,
    },
  },
  {
    id: "Building_area_line",
    type: "line",
    source: "5ec4d27c8c861c736024026f",
    "source-layer": "Building",
    filter: ["all"],
    layout: { visibility: "visible" },
    paint: {
      "line-color": {
        stops: [
          [10, "rgba(23, 22, 22, 0.2)"],
          [20, "rgba(23, 22, 22, 0.45)"],
        ],
      },
      "line-width": {
        stops: [
          [10, 0.5],
          [20, 1.5],
        ],
      },
    },
  },
  {
    id: "road",
    type: "symbol",
    source: "5ec4d27c8c861c736024026f",
    "source-layer": "Centerline",
    layout: {
      "symbol-placement": "line",
      "text-field": "{name}",
      "text-font": ["Kanit"],
      "text-size": 12,
      visibility: "visible",
    },
    paint: {
      "text-color": "rgba(72, 66, 66, 0.94)",
      "text-halo-color": "rgba(249, 245, 245, 0.95)",
      "text-halo-width": 2,
    },
  },
  {
    id: "Landmark_foundation",
    type: "symbol",
    source: "5ec4d27c8c861c736024026f",
    "source-layer": "LandmarkPoint",
    filter: ["all", ["==", "sub_type_code", 1132], ["==", "sub_group", 0]],
    layout: {
      "icon-anchor": "center",
      "icon-image": "foundation",
      "icon-offset": {
        stops: [
          [15, [0, -60]],
          [20, [0, -70]],
        ],
      },
      "icon-size": {
        stops: [
          [10, 0.1],
          [15, 0.12],
          [20, 0.18],
        ],
      },
      "symbol-spacing": 20,
      "text-allow-overlap": false,
      "text-field": "{name}",
      "text-font": ["Kanit"],
      "text-ignore-placement": false,
      "text-justify": "center",
      "text-max-width": 20,
      "text-size": {
        stops: [
          [10, 6],
          [15, 9],
          [20, 11],
        ],
      },
      visibility: "visible",
    },
    paint: {
      "icon-opacity": 0.5,
      "text-color": "rgba(86, 81, 81, 0.97)",
      "text-halo-blur": 1,
      "text-halo-color": "rgba(243, 240, 240, 0.98)",
      "text-halo-width": 2,
    },
  },
  {
    id: "Landmark_intersection",
    type: "symbol",
    source: "5ec4d27c8c861c736024026f",
    "source-layer": "LandmarkPoint",
    filter: ["all", ["==", "sub_type_code", 1131], ["==", "sub_group", 0]],
    layout: {
      "icon-anchor": "center",
      "icon-image": "intersection",
      "icon-offset": {
        stops: [
          [15, [0, -80]],
          [20, [0, -90]],
        ],
      },
      "icon-size": {
        stops: [
          [10, 0.12],
          [15, 0.15],
          [20, 0.18],
        ],
      },
      "symbol-spacing": 20,
      "text-allow-overlap": false,
      "text-field": "{name}",
      "text-font": ["Kanit"],
      "text-ignore-placement": false,
      "text-justify": "center",
      "text-max-width": 20,
      "text-size": {
        stops: [
          [10, 6],
          [15, 9],
          [20, 11],
        ],
      },
      visibility: "visible",
    },
    paint: {
      "icon-opacity": 0.5,
      "text-color": "rgba(86, 81, 81, 0.97)",
      "text-halo-blur": 1,
      "text-halo-color": "rgba(243, 240, 240, 0.98)",
      "text-halo-width": 2,
    },
  },
  {
    id: "Landmark_other",
    type: "symbol",
    source: "5ec4d27c8c861c736024026f",
    "source-layer": "LandmarkPoint",
    filter: ["all", ["==", "sub_type_code", 1130], ["==", "sub_group", 0]],
    layout: {
      "icon-anchor": "center",
      "icon-image": {
        stops: [
          [15, "landmark-JP-11"],
          [20, "landmark-JP-15"],
        ],
      },
      "icon-offset": {
        stops: [
          [15, [0, -8]],
          [20, [0, -10]],
        ],
      },
      "icon-size": 1.2,
      "symbol-spacing": 20,
      "text-allow-overlap": false,
      "text-field": "{name}",
      "text-font": ["Kanit"],
      "text-ignore-placement": false,
      "text-justify": "center",
      "text-max-width": 20,
      "text-size": {
        stops: [
          [10, 6],
          [15, 9],
          [20, 11],
        ],
      },
      visibility: "visible",
    },
    paint: {
      "icon-opacity": 0.5,
      "text-color": "rgba(86, 81, 81, 0.97)",
      "text-halo-blur": 1,
      "text-halo-color": "rgba(243, 240, 240, 0.98)",
      "text-halo-width": 2,
    },
  },
  {
    id: "Landmark_monument",
    type: "symbol",
    source: "5ec4d27c8c861c736024026f",
    "source-layer": "LandmarkPoint",
    filter: ["all", ["==", "sub_type_code", 1129], ["==", "sub_group", 0]],
    layout: {
      "icon-anchor": "center",
      "icon-image": {
        stops: [
          [15, "monument-11"],
          [20, "monument-15"],
        ],
      },
      "icon-offset": {
        stops: [
          [15, [0, -10]],
          [20, [0, -12]],
        ],
      },
      "icon-size": 1.2,
      "symbol-spacing": 20,
      "text-allow-overlap": false,
      "text-field": "{name}",
      "text-font": ["Kanit"],
      "text-ignore-placement": false,
      "text-justify": "center",
      "text-max-width": 20,
      "text-size": {
        stops: [
          [10, 6],
          [15, 9],
          [20, 11],
        ],
      },
      visibility: "visible",
    },
    paint: {
      "icon-opacity": 0.5,
      "text-color": "rgba(86, 81, 81, 0.97)",
      "text-halo-blur": 1,
      "text-halo-color": "rgba(243, 240, 240, 0.98)",
      "text-halo-width": 2,
    },
  },
  {
    id: "Landmark_state_enterprise",
    type: "symbol",
    source: "5ec4d27c8c861c736024026f",
    "source-layer": "LandmarkPoint",
    filter: ["all", ["==", "sub_type_code", 1127], ["==", "sub_group", 0]],
    layout: {
      "icon-anchor": "center",
      "icon-image": "state_enterprise",
      "icon-offset": {
        stops: [
          [15, [0, -60]],
          [20, [0, -70]],
        ],
      },
      "icon-size": {
        stops: [
          [10, 0.12],
          [15, 0.15],
          [20, 0.18],
        ],
      },
      "symbol-spacing": 20,
      "text-allow-overlap": false,
      "text-field": "{name}",
      "text-font": ["Kanit"],
      "text-ignore-placement": false,
      "text-justify": "center",
      "text-max-width": 20,
      "text-size": {
        stops: [
          [10, 6],
          [15, 9],
          [20, 11],
        ],
      },
      visibility: "visible",
    },
    paint: {
      "icon-opacity": 0.5,
      "text-color": "rgba(86, 81, 81, 0.97)",
      "text-halo-blur": 1,
      "text-halo-color": "rgba(243, 240, 240, 0.98)",
      "text-halo-width": 2,
    },
  },
  {
    id: "Landmark_government_other",
    type: "symbol",
    source: "5ec4d27c8c861c736024026f",
    "source-layer": "LandmarkPoint",
    filter: ["all", ["==", "sub_type_code", 1126], ["==", "sub_group", 0]],
    layout: {
      "icon-anchor": "center",
      "icon-image": "other_government ",
      "icon-offset": {
        stops: [
          [15, [0, -80]],
          [20, [0, -80]],
        ],
      },
      "icon-size": {
        stops: [
          [10, 0.12],
          [15, 0.15],
          [20, 0.18],
        ],
      },
      "symbol-spacing": 20,
      "text-allow-overlap": false,
      "text-field": "{name}",
      "text-font": ["Kanit"],
      "text-ignore-placement": false,
      "text-justify": "center",
      "text-max-width": 20,
      "text-size": {
        stops: [
          [10, 6],
          [15, 9],
          [20, 11],
        ],
      },
      visibility: "visible",
    },
    paint: {
      "icon-opacity": 0.5,
      "text-color": "rgba(86, 81, 81, 0.97)",
      "text-halo-blur": 1,
      "text-halo-color": "rgba(243, 240, 240, 0.98)",
      "text-halo-width": 2,
    },
  },
  {
    id: "Landmark_tollbooth",
    type: "symbol",
    source: "5ec4d27c8c861c736024026f",
    "source-layer": "LandmarkPoint",
    filter: ["all", ["==", "sub_type_code", 1125], ["==", "sub_group", 0]],
    layout: {
      "icon-anchor": "center",
      "icon-image": "tollbooth",
      "icon-offset": {
        stops: [
          [15, [0, -300]],
          [20, [0, -350]],
        ],
      },
      "icon-size": {
        stops: [
          [10, 0.02],
          [15, 0.04],
          [20, 0.05],
        ],
      },
      "symbol-spacing": 20,
      "text-allow-overlap": false,
      "text-field": "{name}",
      "text-font": ["Kanit"],
      "text-ignore-placement": false,
      "text-justify": "center",
      "text-max-width": 20,
      "text-size": {
        stops: [
          [10, 8],
          [15, 10],
          [20, 12],
        ],
      },
      visibility: "visible",
    },
    paint: {
      "icon-opacity": 0.5,
      "text-color": "rgba(86, 81, 81, 0.97)",
      "text-halo-blur": 1,
      "text-halo-color": "rgba(243, 240, 240, 0.98)",
      "text-halo-width": 2,
    },
  },
  {
    id: "Landmark_airport",
    type: "symbol",
    source: "5ec4d27c8c861c736024026f",
    "source-layer": "LandmarkPoint",
    filter: ["all", ["==", "sub_type_code", 1124], ["==", "sub_group", 5]],
    layout: {
      "icon-anchor": "center",
      "icon-image": {
        stops: [
          [15, "airport-11"],
          [20, "airport-15"],
        ],
      },
      "icon-offset": {
        stops: [
          [15, [0, -8]],
          [20, [0, -12]],
        ],
      },
      "icon-size": 2,
      "symbol-spacing": 20,
      "text-allow-overlap": false,
      "text-field": "{name}",
      "text-font": ["Kanit"],
      "text-ignore-placement": false,
      "text-justify": "center",
      "text-max-width": 20,
      "text-size": {
        stops: [
          [10, 8],
          [15, 10],
          [20, 12],
        ],
      },
      visibility: "visible",
    },
    paint: {
      "icon-opacity": 0.5,
      "text-color": "rgba(86, 81, 81, 0.97)",
      "text-halo-blur": 1,
      "text-halo-color": "rgba(243, 240, 240, 0.98)",
      "text-halo-width": 2,
    },
  },
  {
    id: "Landmark_port",
    type: "symbol",
    source: "5ec4d27c8c861c736024026f",
    "source-layer": "LandmarkPoint",
    filter: ["all", ["==", "sub_type_code", 1124], ["==", "sub_group", 4]],
    layout: {
      "icon-anchor": "center",
      "icon-image": {
        stops: [
          [15, "ferry-11"],
          [20, "ferry-15"],
        ],
      },
      "icon-offset": {
        stops: [
          [15, [0, -10]],
          [20, [0, -10]],
        ],
      },
      "icon-size": 1.2,
      "symbol-spacing": 20,
      "text-allow-overlap": false,
      "text-field": "{name}",
      "text-font": ["Kanit"],
      "text-ignore-placement": false,
      "text-justify": "center",
      "text-max-width": 20,
      "text-size": {
        stops: [
          [10, 6],
          [15, 9],
          [20, 11],
        ],
      },
      visibility: "visible",
    },
    paint: {
      "icon-opacity": 0.5,
      "text-color": "rgba(86, 81, 81, 0.97)",
      "text-halo-blur": 1,
      "text-halo-color": "rgba(243, 240, 240, 0.98)",
      "text-halo-width": 2,
    },
  },
  {
    id: "Landmark_rail_station",
    type: "symbol",
    source: "5ec4d27c8c861c736024026f",
    "source-layer": "LandmarkPoint",
    filter: ["all", ["==", "sub_type_code", 1124], ["==", "sub_group", 3]],
    layout: {
      "icon-anchor": "center",
      "icon-image": {
        stops: [
          [15, "rail-11"],
          [20, "rail-15"],
        ],
      },
      "icon-offset": {
        stops: [
          [15, [0, -10]],
          [20, [0, -10]],
        ],
      },
      "icon-size": 1.2,
      "symbol-spacing": 20,
      "text-allow-overlap": false,
      "text-field": "{name}",
      "text-font": ["Kanit"],
      "text-ignore-placement": false,
      "text-justify": "center",
      "text-max-width": 20,
      "text-size": {
        stops: [
          [10, 6],
          [15, 9],
          [20, 11],
        ],
      },
      visibility: "visible",
    },
    paint: {
      "icon-opacity": 0.5,
      "text-color": "rgba(86, 81, 81, 0.97)",
      "text-halo-blur": 1,
      "text-halo-color": "rgba(243, 240, 240, 0.98)",
      "text-halo-width": 2,
    },
  },
  {
    id: "Landmark_rail_metro",
    type: "symbol",
    source: "5ec4d27c8c861c736024026f",
    "source-layer": "LandmarkPoint",
    filter: ["all", ["==", "sub_type_code", 1124], ["==", "sub_group", 2]],
    layout: {
      "icon-anchor": "center",
      "icon-image": {
        stops: [
          [15, "rail-light-15"],
          [20, "rail-light-15"],
        ],
      },
      "icon-offset": {
        stops: [
          [15, [0, -10]],
          [20, [0, -10]],
        ],
      },
      "icon-size": 1.2,
      "symbol-spacing": 20,
      "text-allow-overlap": false,
      "text-field": "{name}",
      "text-font": ["Kanit"],
      "text-ignore-placement": false,
      "text-justify": "center",
      "text-max-width": 20,
      "text-size": {
        stops: [
          [10, 6],
          [15, 9],
          [20, 11],
        ],
      },
      visibility: "visible",
    },
    paint: {
      "icon-opacity": 0.5,
      "text-color": "rgba(86, 81, 81, 0.97)",
      "text-halo-blur": 1,
      "text-halo-color": "rgba(243, 240, 240, 0.98)",
      "text-halo-width": 2,
    },
  },
  {
    id: "Landmark_transport_station2",
    type: "symbol",
    source: "5ec4d27c8c861c736024026f",
    "source-layer": "LandmarkPoint",
    filter: ["all", ["==", "sub_type_code", 1124], ["==", "sub_group", 1]],
    layout: {
      "icon-anchor": "center",
      "icon-image": {
        stops: [
          [15, "bus-11"],
          [20, "bus-15"],
        ],
      },
      "icon-offset": {
        stops: [
          [15, [0, -10]],
          [20, [0, -10]],
        ],
      },
      "icon-size": 1,
      "symbol-spacing": 20,
      "text-allow-overlap": false,
      "text-field": "{name}",
      "text-font": ["Kanit"],
      "text-ignore-placement": false,
      "text-justify": "center",
      "text-max-width": 20,
      "text-size": {
        stops: [
          [10, 6],
          [15, 9],
          [20, 11],
        ],
      },
      visibility: "visible",
    },
    paint: {
      "icon-opacity": 0.5,
      "text-color": "rgba(86, 81, 81, 0.97)",
      "text-halo-blur": 1,
      "text-halo-color": "rgba(243, 240, 240, 0.98)",
      "text-halo-width": 2,
    },
  },
  {
    id: "Landmark_transport_station",
    type: "symbol",
    source: "5ec4d27c8c861c736024026f",
    "source-layer": "LandmarkPoint",
    filter: ["all", ["==", "sub_type_code", 1124], ["==", "sub_group", 0]],
    layout: {
      "icon-anchor": "center",
      "icon-image": {
        stops: [
          [15, "bus-11"],
          [20, "bus-15"],
        ],
      },
      "icon-offset": {
        stops: [
          [15, [0, -10]],
          [20, [0, -10]],
        ],
      },
      "icon-size": 1,
      "symbol-spacing": 20,
      "text-allow-overlap": false,
      "text-field": "{name}",
      "text-font": ["Kanit"],
      "text-ignore-placement": false,
      "text-justify": "center",
      "text-max-width": 20,
      "text-size": {
        stops: [
          [10, 6],
          [15, 9],
          [20, 11],
        ],
      },
      visibility: "visible",
    },
    paint: {
      "icon-opacity": 0.5,
      "text-color": "rgba(86, 81, 81, 0.97)",
      "text-halo-blur": 1,
      "text-halo-color": "rgba(243, 240, 240, 0.98)",
      "text-halo-width": 2,
    },
  },
  {
    id: "Landmark_palace",
    type: "symbol",
    source: "5ec4d27c8c861c736024026f",
    "source-layer": "LandmarkPoint",
    filter: ["all", ["==", "sub_type_code", 1123], ["==", "sub_group", 0]],
    layout: {
      "icon-anchor": "center",
      "icon-image": "palace",
      "icon-offset": {
        stops: [
          [15, [0, -80]],
          [20, [0, -80]],
        ],
      },
      "icon-size": {
        stops: [
          [10, 0.08],
          [15, 0.1],
          [20, 0.15],
        ],
      },
      "symbol-spacing": 20,
      "text-allow-overlap": false,
      "text-field": "{name}",
      "text-font": ["Kanit"],
      "text-ignore-placement": false,
      "text-justify": "center",
      "text-max-width": 20,
      "text-size": {
        stops: [
          [10, 6],
          [15, 9],
          [20, 11],
        ],
      },
      visibility: "visible",
    },
    paint: {
      "icon-opacity": 0.5,
      "text-color": "rgba(86, 81, 81, 0.97)",
      "text-halo-blur": 1,
      "text-halo-color": "rgba(243, 240, 240, 0.98)",
      "text-halo-width": 2,
    },
  },
  {
    id: "Landmark_tomb",
    type: "symbol",
    source: "5ec4d27c8c861c736024026f",
    "source-layer": "LandmarkPoint",
    filter: ["all", ["==", "sub_type_code", 1122], ["==", "sub_group", 7]],
    layout: {
      "icon-anchor": "center",
      "icon-image": "tomb",
      "icon-offset": {
        stops: [
          [15, [0, -80]],
          [20, [0, -80]],
        ],
      },
      "icon-size": {
        stops: [
          [10, 0.08],
          [15, 0.1],
          [20, 0.12],
        ],
      },
      "symbol-spacing": 20,
      "text-allow-overlap": false,
      "text-field": "{name}",
      "text-font": ["Kanit"],
      "text-ignore-placement": false,
      "text-justify": "center",
      "text-max-width": 20,
      "text-size": {
        stops: [
          [10, 6],
          [15, 9],
          [20, 11],
        ],
      },
      visibility: "visible",
    },
    paint: {
      "icon-opacity": 0.5,
      "text-color": "rgba(86, 81, 81, 0.97)",
      "text-halo-blur": 1,
      "text-halo-color": "rgba(243, 240, 240, 0.98)",
      "text-halo-width": 2,
    },
  },
  {
    id: "Landmark_tabernacle",
    type: "symbol",
    source: "5ec4d27c8c861c736024026f",
    "source-layer": "LandmarkPoint",
    filter: ["all", ["==", "sub_type_code", 1122], ["==", "sub_group", 6]],
    layout: {
      "icon-anchor": "center",
      "icon-image": "torii-gate",
      "icon-offset": {
        stops: [
          [15, [0, -12]],
          [20, [0, -12]],
        ],
      },
      "icon-size": {
        stops: [
          [10, 0.4],
          [15, 0.6],
          [20, 0.8],
        ],
      },
      "symbol-spacing": 20,
      "text-allow-overlap": false,
      "text-field": "{name}",
      "text-font": ["Kanit"],
      "text-ignore-placement": false,
      "text-justify": "center",
      "text-max-width": 20,
      "text-size": {
        stops: [
          [10, 6],
          [15, 9],
          [20, 11],
        ],
      },
      visibility: "visible",
    },
    paint: {
      "icon-opacity": 0.5,
      "text-color": "rgba(86, 81, 81, 0.97)",
      "text-halo-blur": 1,
      "text-halo-color": "rgba(243, 240, 240, 0.98)",
      "text-halo-width": 2,
    },
  },
  {
    id: "Landmark_pagoda",
    type: "symbol",
    source: "5ec4d27c8c861c736024026f",
    "source-layer": "LandmarkPoint",
    filter: ["all", ["==", "sub_type_code", 1122], ["==", "sub_group", 5]],
    layout: {
      "icon-anchor": "center",
      "icon-image": "pagoda",
      "icon-offset": {
        stops: [
          [15, [0, -70]],
          [20, [0, -80]],
        ],
      },
      "icon-size": {
        stops: [
          [10, 0.12],
          [15, 0.14],
          [20, 0.16],
        ],
      },
      "symbol-spacing": 20,
      "text-allow-overlap": false,
      "text-field": "{name}",
      "text-font": ["Kanit"],
      "text-ignore-placement": false,
      "text-justify": "center",
      "text-max-width": 20,
      "text-size": {
        stops: [
          [10, 6],
          [15, 9],
          [20, 11],
        ],
      },
      visibility: "visible",
    },
    paint: {
      "icon-opacity": 0.5,
      "text-color": "rgba(86, 81, 81, 0.97)",
      "text-halo-blur": 1,
      "text-halo-color": "rgba(243, 240, 240, 0.98)",
      "text-halo-width": 2,
    },
  },
  {
    id: "Landmark_chinese_temple",
    type: "symbol",
    source: "5ec4d27c8c861c736024026f",
    "source-layer": "LandmarkPoint",
    filter: ["all", ["==", "sub_type_code", 1122], ["==", "sub_group", 4]],
    layout: {
      "icon-anchor": "center",
      "icon-image": "chinese_temple",
      "icon-offset": {
        stops: [
          [15, [0, -60]],
          [20, [0, -70]],
        ],
      },
      "icon-size": {
        stops: [
          [10, 0.12],
          [15, 0.15],
          [20, 0.18],
        ],
      },
      "symbol-spacing": 20,
      "text-allow-overlap": false,
      "text-field": "{name}",
      "text-font": ["Kanit"],
      "text-ignore-placement": false,
      "text-justify": "center",
      "text-max-width": 20,
      "text-size": {
        stops: [
          [10, 6],
          [15, 9],
          [20, 11],
        ],
      },
      visibility: "visible",
    },
    paint: {
      "icon-opacity": 0.5,
      "text-color": "rgba(86, 81, 81, 0.97)",
      "text-halo-blur": 1,
      "text-halo-color": "rgba(243, 240, 240, 0.98)",
      "text-halo-width": 2,
    },
  },
  {
    id: "Landmark_temple",
    type: "symbol",
    source: "5ec4d27c8c861c736024026f",
    "source-layer": "LandmarkPoint",
    filter: ["all", ["==", "sub_type_code", 1122], ["==", "sub_group", 3]],
    layout: {
      "icon-anchor": "center",
      "icon-image": "temple",
      "icon-offset": {
        stops: [
          [15, [0, -60]],
          [20, [0, -60]],
        ],
      },
      "icon-size": {
        stops: [
          [10, 0.12],
          [15, 0.15],
          [20, 0.18],
        ],
      },
      "symbol-spacing": 20,
      "text-allow-overlap": false,
      "text-field": "{name}",
      "text-font": ["Kanit"],
      "text-ignore-placement": false,
      "text-justify": "center",
      "text-max-width": 20,
      "text-size": {
        stops: [
          [10, 6],
          [15, 9],
          [20, 11],
        ],
      },
      visibility: "visible",
    },
    paint: {
      "icon-opacity": 0.5,
      "text-color": "rgba(86, 81, 81, 0.97)",
      "text-halo-blur": 1,
      "text-halo-color": "rgba(243, 240, 240, 0.98)",
      "text-halo-width": 2,
    },
  },
  {
    id: "Landmark_islamism_church",
    type: "symbol",
    source: "5ec4d27c8c861c736024026f",
    "source-layer": "LandmarkPoint",
    filter: ["all", ["==", "sub_type_code", 1122], ["==", "sub_group", 2]],
    layout: {
      "icon-anchor": "center",
      "icon-image": "islamism_church",
      "icon-offset": {
        stops: [
          [15, [0, -80]],
          [20, [0, -70]],
        ],
      },
      "icon-size": {
        stops: [
          [10, 0.12],
          [15, 0.14],
          [20, 0.16],
        ],
      },
      "symbol-spacing": 20,
      "text-allow-overlap": false,
      "text-field": "{name}",
      "text-font": ["Kanit"],
      "text-ignore-placement": false,
      "text-justify": "center",
      "text-max-width": 20,
      "text-size": {
        stops: [
          [10, 6],
          [15, 9],
          [20, 11],
        ],
      },
      visibility: "visible",
    },
    paint: {
      "icon-opacity": 0.5,
      "text-color": "rgba(86, 81, 81, 0.97)",
      "text-halo-blur": 1,
      "text-halo-color": "rgba(243, 240, 240, 0.98)",
      "text-halo-width": 2,
    },
  },
  {
    id: "Landmark_christ_church",
    type: "symbol",
    source: "5ec4d27c8c861c736024026f",
    "source-layer": "LandmarkPoint",
    filter: ["all", ["==", "sub_type_code", 1122], ["==", "sub_group", 1]],
    layout: {
      "icon-anchor": "center",
      "icon-image": "christ_church",
      "icon-offset": {
        stops: [
          [15, [0, -80]],
          [20, [0, -70]],
        ],
      },
      "icon-size": {
        stops: [
          [10, 0.12],
          [15, 0.14],
          [20, 0.16],
        ],
      },
      "symbol-spacing": 20,
      "text-allow-overlap": false,
      "text-field": "{name}",
      "text-font": ["Kanit"],
      "text-ignore-placement": false,
      "text-justify": "center",
      "text-max-width": 20,
      "text-size": {
        stops: [
          [10, 6],
          [15, 9],
          [20, 11],
        ],
      },
      visibility: "visible",
    },
    paint: {
      "icon-opacity": 0.5,
      "text-color": "rgba(86, 81, 81, 0.97)",
      "text-halo-blur": 1,
      "text-halo-color": "rgba(243, 240, 240, 0.98)",
      "text-halo-width": 2,
    },
  },
  {
    id: "Landmark_religion",
    type: "symbol",
    source: "5ec4d27c8c861c736024026f",
    "source-layer": "LandmarkPoint",
    filter: ["all", ["==", "sub_type_code", 1122], ["==", "sub_group", 0]],
    layout: {
      "icon-anchor": "center",
      "icon-image": "religious_place",
      "icon-offset": {
        stops: [
          [15, [0, -80]],
          [20, [0, -70]],
        ],
      },
      "icon-size": {
        stops: [
          [10, 0.12],
          [15, 0.13],
          [20, 0.15],
        ],
      },
      "symbol-spacing": 20,
      "text-allow-overlap": false,
      "text-field": "{name}",
      "text-font": ["Kanit"],
      "text-ignore-placement": false,
      "text-justify": "center",
      "text-max-width": 20,
      "text-size": {
        stops: [
          [10, 6],
          [15, 9],
          [20, 11],
        ],
      },
      visibility: "visible",
    },
    paint: {
      "icon-opacity": 0.5,
      "text-color": "rgba(86, 81, 81, 0.97)",
      "text-halo-blur": 1,
      "text-halo-color": "rgba(243, 240, 240, 0.98)",
      "text-halo-width": 2,
    },
  },
  {
    id: "Landmark_postoffice",
    type: "symbol",
    source: "5ec4d27c8c861c736024026f",
    "source-layer": "LandmarkPoint",
    filter: ["all", ["==", "sub_type_code", 1121], ["==", "sub_group", 0]],
    layout: {
      "icon-anchor": "center",
      "icon-image": "post_office",
      "icon-offset": {
        stops: [
          [15, [0, -70]],
          [20, [0, -70]],
        ],
      },
      "icon-size": {
        stops: [
          [10, 0.13],
          [15, 0.14],
          [20, 0.16],
        ],
      },
      "symbol-spacing": 20,
      "text-allow-overlap": false,
      "text-field": "{name}",
      "text-font": ["Kanit"],
      "text-ignore-placement": false,
      "text-justify": "center",
      "text-max-width": 20,
      "text-size": {
        stops: [
          [10, 6],
          [15, 9],
          [20, 11],
        ],
      },
      visibility: "visible",
    },
    paint: {
      "icon-opacity": 0.5,
      "text-color": "rgba(86, 81, 81, 0.97)",
      "text-halo-blur": 1,
      "text-halo-color": "rgba(243, 240, 240, 0.98)",
      "text-halo-width": 2,
    },
  },
  {
    id: "Landmark_tot",
    type: "symbol",
    source: "5ec4d27c8c861c736024026f",
    "source-layer": "LandmarkPoint",
    filter: ["all", ["==", "sub_type_code", 1120], ["==", "sub_group", 0]],
    layout: {
      "icon-anchor": "center",
      "icon-image": "tot",
      "icon-offset": {
        stops: [
          [15, [0, -150]],
          [20, [0, -100]],
        ],
      },
      "icon-size": {
        stops: [
          [10, 0],
          [15, 0.05],
          [20, 0.1],
        ],
      },
      "symbol-spacing": 20,
      "text-allow-overlap": false,
      "text-field": "{name}",
      "text-font": ["Kanit"],
      "text-ignore-placement": false,
      "text-justify": "center",
      "text-max-width": 20,
      "text-size": {
        stops: [
          [10, 6],
          [15, 9],
          [20, 11],
        ],
      },
      visibility: "visible",
    },
    paint: {
      "text-color": "rgba(86, 81, 81, 0.97)",
      "text-halo-blur": 1,
      "text-halo-color": "rgba(243, 240, 240, 0.98)",
      "text-halo-width": 2,
    },
  },
  {
    id: "Landmark_mwa_water_station",
    type: "symbol",
    source: "5ec4d27c8c861c736024026f",
    "source-layer": "LandmarkPoint",
    filter: ["all", ["==", "sub_type_code", 1119], ["==", "sub_group", 0]],
    layout: {
      "icon-anchor": "center",
      "icon-image": "mwa",
      "icon-offset": {
        stops: [
          [15, [0, -350]],
          [20, [0, -300]],
        ],
      },
      "icon-size": {
        stops: [
          [10, 0.025],
          [15, 0.03],
          [20, 0.035],
        ],
      },
      "symbol-spacing": 20,
      "text-allow-overlap": false,
      "text-field": "{name}",
      "text-font": ["Kanit"],
      "text-ignore-placement": false,
      "text-justify": "center",
      "text-max-width": 20,
      "text-size": {
        stops: [
          [10, 6],
          [15, 9],
          [20, 11],
        ],
      },
      visibility: "visible",
    },
    paint: {
      "text-color": "rgba(86, 81, 81, 0.97)",
      "text-halo-blur": 1,
      "text-halo-color": "rgba(243, 240, 240, 0.98)",
      "text-halo-width": 2,
    },
  },
  {
    id: "Landmark_mwa_office",
    type: "symbol",
    source: "5ec4d27c8c861c736024026f",
    "source-layer": "LandmarkPoint",
    filter: ["all", ["==", "sub_type_code", 1119], ["==", "sub_group", 0]],
    layout: {
      "icon-anchor": "center",
      "icon-image": "mwa",
      "icon-offset": {
        stops: [
          [15, [0, -350]],
          [20, [0, -300]],
        ],
      },
      "icon-size": {
        stops: [
          [10, 0.025],
          [15, 0.03],
          [20, 0.035],
        ],
      },
      "symbol-spacing": 20,
      "text-allow-overlap": false,
      "text-field": "{name}",
      "text-font": ["Kanit"],
      "text-ignore-placement": false,
      "text-justify": "center",
      "text-max-width": 20,
      "text-size": {
        stops: [
          [10, 6],
          [15, 9],
          [20, 11],
        ],
      },
      visibility: "visible",
    },
    paint: {
      "text-color": "rgba(86, 81, 81, 0.97)",
      "text-halo-blur": 1,
      "text-halo-color": "rgba(243, 240, 240, 0.98)",
      "text-halo-width": 2,
    },
  },
  {
    id: "Landmark_mwa",
    type: "symbol",
    source: "5ec4d27c8c861c736024026f",
    "source-layer": "LandmarkPoint",
    filter: ["all", ["==", "sub_type_code", 1119], ["==", "sub_group", 0]],
    layout: {
      "icon-anchor": "center",
      "icon-image": "mwa",
      "icon-offset": {
        stops: [
          [15, [0, -350]],
          [20, [0, -300]],
        ],
      },
      "icon-size": {
        stops: [
          [10, 0.025],
          [15, 0.03],
          [20, 0.035],
        ],
      },
      "symbol-spacing": 20,
      "text-allow-overlap": false,
      "text-field": "{name}",
      "text-font": ["Kanit"],
      "text-ignore-placement": false,
      "text-justify": "center",
      "text-max-width": 20,
      "text-size": {
        stops: [
          [10, 6],
          [15, 9],
          [20, 11],
        ],
      },
      visibility: "visible",
    },
    paint: {
      "text-color": "rgba(86, 81, 81, 0.97)",
      "text-halo-blur": 1,
      "text-halo-color": "rgba(243, 240, 240, 0.98)",
      "text-halo-width": 2,
    },
  },
  {
    id: "Landmark_mea_sub_office",
    type: "symbol",
    source: "5ec4d27c8c861c736024026f",
    "source-layer": "LandmarkPoint",
    filter: ["all", ["==", "sub_type_code", 1118], ["==", "sub_group", 2]],
    layout: {
      "icon-anchor": "center",
      "icon-image": "mea",
      "icon-offset": {
        stops: [
          [15, [0, -350]],
          [20, [0, -300]],
        ],
      },
      "icon-size": {
        stops: [
          [10, 0.02],
          [15, 0.03],
          [20, 0.04],
        ],
      },
      "symbol-spacing": 20,
      "text-allow-overlap": false,
      "text-field": "{name}",
      "text-font": ["Kanit"],
      "text-ignore-placement": false,
      "text-justify": "center",
      "text-max-width": 20,
      "text-size": {
        stops: [
          [10, 6],
          [15, 9],
          [20, 11],
        ],
      },
      visibility: "visible",
    },
    paint: {
      "text-color": "rgba(86, 81, 81, 0.97)",
      "text-halo-blur": 1,
      "text-halo-color": "rgba(243, 240, 240, 0.98)",
      "text-halo-width": 2,
    },
  },
  {
    id: "Landmark_mea_office",
    type: "symbol",
    source: "5ec4d27c8c861c736024026f",
    "source-layer": "LandmarkPoint",
    filter: ["all", ["==", "sub_type_code", 1118], ["==", "sub_group", 1]],
    layout: {
      "icon-anchor": "center",
      "icon-image": "mea",
      "icon-offset": {
        stops: [
          [15, [0, -350]],
          [20, [0, -300]],
        ],
      },
      "icon-size": {
        stops: [
          [10, 0.02],
          [15, 0.03],
          [20, 0.04],
        ],
      },
      "symbol-spacing": 20,
      "text-allow-overlap": false,
      "text-field": "{name}",
      "text-font": ["Kanit"],
      "text-ignore-placement": false,
      "text-justify": "center",
      "text-max-width": 20,
      "text-size": {
        stops: [
          [10, 6],
          [15, 9],
          [20, 11],
        ],
      },
      visibility: "visible",
    },
    paint: {
      "text-color": "rgba(86, 81, 81, 0.97)",
      "text-halo-blur": 1,
      "text-halo-color": "rgba(243, 240, 240, 0.98)",
      "text-halo-width": 2,
    },
  },
  {
    id: "Landmark_mea",
    type: "symbol",
    source: "5ec4d27c8c861c736024026f",
    "source-layer": "LandmarkPoint",
    filter: ["all", ["==", "sub_type_code", 1118], ["==", "sub_group", 0]],
    layout: {
      "icon-anchor": "center",
      "icon-image": "mea",
      "icon-offset": {
        stops: [
          [15, [0, -350]],
          [20, [0, -300]],
        ],
      },
      "icon-size": {
        stops: [
          [10, 0.02],
          [15, 0.03],
          [20, 0.04],
        ],
      },
      "symbol-spacing": 20,
      "text-allow-overlap": false,
      "text-field": "{name}",
      "text-font": ["Kanit"],
      "text-ignore-placement": false,
      "text-justify": "center",
      "text-max-width": 20,
      "text-size": {
        stops: [
          [10, 6],
          [15, 9],
          [20, 11],
        ],
      },
      visibility: "visible",
    },
    paint: {
      "text-color": "rgba(86, 81, 81, 0.97)",
      "text-halo-blur": 1,
      "text-halo-color": "rgba(243, 240, 240, 0.98)",
      "text-halo-width": 2,
    },
  },
  {
    id: "Landmark_district_office",
    type: "symbol",
    source: "5ec4d27c8c861c736024026f",
    "source-layer": "LandmarkPoint",
    filter: ["all", ["==", "sub_type_code", 1117], ["==", "sub_group", 1]],
    layout: {
      "icon-anchor": "center",
      "icon-image": "district_office2",
      "icon-offset": {
        stops: [
          [15, [0, -90]],
          [22, [0, -90]],
        ],
      },
      "icon-size": {
        stops: [
          [1, 0.01],
          [15, 0.05],
          [20, 0.15],
        ],
      },
      "symbol-spacing": 20,
      "text-allow-overlap": false,
      "text-field": "{name}",
      "text-font": ["Kanit"],
      "text-ignore-placement": false,
      "text-justify": "center",
      "text-max-width": 20,
      "text-size": {
        stops: [
          [10, 6],
          [15, 9],
          [20, 11],
        ],
      },
      visibility: "visible",
    },
    paint: {
      "icon-opacity": 0.5,
      "text-color": "rgba(86, 81, 81, 0.97)",
      "text-halo-blur": 1,
      "text-halo-color": "rgba(243, 240, 240, 0.98)",
      "text-halo-width": 2,
    },
  },
  {
    id: "Landmark_government_bangkok",
    type: "symbol",
    source: "5ec4d27c8c861c736024026f",
    "source-layer": "LandmarkPoint",
    filter: ["all", ["==", "sub_type_code", 1117], ["==", "sub_group", 0]],
    layout: {
      "icon-anchor": "center",
      "icon-image": "government_bangkok",
      "icon-offset": {
        stops: [
          [15, [0, -90]],
          [22, [0, -90]],
        ],
      },
      "icon-size": {
        stops: [
          [1, 0.1],
          [15, 0.05],
          [20, 0.15],
        ],
      },
      "symbol-spacing": 20,
      "text-allow-overlap": false,
      "text-field": "{name}",
      "text-font": ["Kanit"],
      "text-ignore-placement": false,
      "text-justify": "center",
      "text-max-width": 20,
      "text-size": {
        stops: [
          [10, 6],
          [15, 9],
          [20, 11],
        ],
      },
      visibility: "visible",
    },
    paint: {
      "icon-opacity": 0.5,
      "text-color": "rgba(86, 81, 81, 0.97)",
      "text-halo-blur": 1,
      "text-halo-color": "rgba(243, 240, 240, 0.98)",
      "text-halo-width": 2,
    },
  },
  {
    id: "Landmark_polistation",
    type: "symbol",
    source: "5ec4d27c8c861c736024026f",
    "source-layer": "LandmarkPoint",
    filter: ["all", ["==", "sub_type_code", 1116], ["==", "sub_group", 0]],
    layout: {
      "icon-anchor": "center",
      "icon-image": {
        stops: [
          [15, "police-11"],
          [20, "police-15"],
        ],
      },
      "icon-offset": {
        stops: [
          [15, [0, -10]],
          [22, [0, -10]],
        ],
      },
      "icon-size": 1,
      "symbol-spacing": 20,
      "text-allow-overlap": false,
      "text-field": "{name}",
      "text-font": ["Kanit"],
      "text-ignore-placement": false,
      "text-justify": "center",
      "text-max-width": 10,
      "text-size": {
        stops: [
          [10, 6],
          [15, 9],
          [20, 11],
        ],
      },
      visibility: "visible",
    },
    paint: {
      "icon-opacity": 0.5,
      "text-color": "rgba(86, 81, 81, 0.97)",
      "text-halo-blur": 1,
      "text-halo-color": "rgba(243, 240, 240, 0.98)",
      "text-halo-width": 2,
    },
  },
  {
    id: "Landmark_embassy",
    type: "symbol",
    source: "5ec4d27c8c861c736024026f",
    "source-layer": "LandmarkPoint",
    filter: ["all", ["==", "sub_type_code", 1115], ["==", "sub_group", 0]],
    layout: {
      "icon-anchor": "center",
      "icon-image": {
        stops: [
          [15, "embassy-11"],
          [20, "embassy-15"],
        ],
      },
      "icon-offset": {
        stops: [
          [15, [0, -10]],
          [22, [0, -10]],
        ],
      },
      "icon-size": 1,
      "symbol-spacing": 20,
      "text-allow-overlap": false,
      "text-field": "{name}",
      "text-font": ["Kanit"],
      "text-ignore-placement": false,
      "text-justify": "center",
      "text-max-width": 20,
      "text-size": {
        stops: [
          [10, 6],
          [15, 9],
          [20, 11],
        ],
      },
      visibility: "visible",
    },
    paint: {
      "icon-opacity": 0.5,
      "text-color": "rgba(86, 81, 81, 0.97)",
      "text-halo-blur": 1,
      "text-halo-color": "rgba(243, 240, 240, 0.98)",
      "text-halo-width": 2,
    },
  },
  {
    id: "Landmark_market",
    type: "symbol",
    source: "5ec4d27c8c861c736024026f",
    "source-layer": "LandmarkPoint",
    filter: ["all", ["==", "sub_type_code", 1114], ["==", "sub_group", 0]],
    layout: {
      "icon-anchor": "center",
      "icon-image": "market",
      "icon-offset": {
        stops: [
          [15, [0, -70]],
          [22, [0, -80]],
        ],
      },
      "icon-size": {
        stops: [
          [10, 0.12],
          [15, 0.12],
          [20, 0.15],
        ],
      },
      "symbol-spacing": 20,
      "text-allow-overlap": false,
      "text-field": "{name}",
      "text-font": ["Kanit"],
      "text-ignore-placement": false,
      "text-justify": "center",
      "text-max-width": 20,
      "text-size": {
        stops: [
          [10, 6],
          [15, 9],
          [20, 11],
        ],
      },
      visibility: "visible",
    },
    paint: {
      "icon-opacity": 0.5,
      "text-color": "rgba(86, 81, 81, 0.97)",
      "text-halo-blur": 1,
      "text-halo-color": "rgba(243, 240, 240, 0.98)",
      "text-halo-width": 2,
    },
  },
  {
    id: "Landmark_lotus_exxpress",
    type: "symbol",
    source: "5ec4d27c8c861c736024026f",
    "source-layer": "LandmarkPoint",
    filter: ["all", ["==", "sub_type_code", 1113], ["==", "sub_group", 5]],
    layout: {
      "icon-anchor": "center",
      "icon-image": "lotus_express",
      "icon-offset": {
        stops: [
          [15, [0, -350]],
          [22, [0, -300]],
        ],
      },
      "icon-size": {
        stops: [
          [15, 0.02],
          [20, 0.04],
          [21, 0.05],
        ],
      },
      "symbol-spacing": 20,
      "text-allow-overlap": false,
      "text-field": "{name}",
      "text-font": ["Kanit"],
      "text-ignore-placement": false,
      "text-justify": "center",
      "text-max-width": 20,
      "text-size": {
        stops: [
          [10, 6],
          [15, 9],
          [20, 11],
        ],
      },
      visibility: "visible",
    },
    paint: {
      "text-color": "rgba(86, 81, 81, 0.97)",
      "text-halo-blur": 1,
      "text-halo-color": "rgba(243, 240, 240, 0.98)",
      "text-halo-width": 2,
    },
  },
  {
    id: "Landmark_v_shop",
    type: "symbol",
    source: "5ec4d27c8c861c736024026f",
    "source-layer": "LandmarkPoint",
    filter: ["all", ["==", "sub_type_code", 1113], ["==", "sub_group", 4]],
    layout: {
      "icon-anchor": "center",
      "icon-offset": {
        stops: [
          [15, [0, -300]],
          [20, [0, -350]],
        ],
      },
      "icon-size": {
        stops: [
          [10, 0.02],
          [15, 0.02],
          [20, 0.035],
        ],
      },
      "symbol-spacing": 20,
      "text-allow-overlap": false,
      "text-field": "",
      "text-font": ["Kanit"],
      "text-ignore-placement": false,
      "text-justify": "center",
      "text-max-width": 20,
      "text-size": {
        stops: [
          [10, 6],
          [15, 9],
          [20, 11],
        ],
      },
      visibility: "visible",
    },
    paint: {
      "text-color": "rgba(86, 81, 81, 0.97)",
      "text-halo-blur": 1,
      "text-halo-color": "rgba(243, 240, 240, 0.98)",
      "text-halo-width": 2,
    },
  },
  {
    id: "Landmark_shop_familymark",
    type: "symbol",
    source: "5ec4d27c8c861c736024026f",
    "source-layer": "LandmarkPoint",
    filter: ["all", ["==", "sub_type_code", 1113], ["==", "sub_group", 3]],
    layout: {
      "icon-anchor": "center",
      "icon-image": "shop_familymart",
      "icon-offset": {
        stops: [
          [15, [0, -300]],
          [20, [0, -350]],
        ],
      },
      "icon-size": {
        stops: [
          [10, 0.02],
          [15, 0.02],
          [20, 0.035],
        ],
      },
      "symbol-spacing": 20,
      "text-allow-overlap": false,
      "text-field": "{name}",
      "text-font": ["Kanit"],
      "text-ignore-placement": false,
      "text-justify": "center",
      "text-max-width": 20,
      "text-size": {
        stops: [
          [10, 6],
          [15, 9],
          [20, 11],
        ],
      },
      visibility: "visible",
    },
    paint: {
      "text-color": "rgba(86, 81, 81, 0.97)",
      "text-halo-blur": 1,
      "text-halo-color": "rgba(243, 240, 240, 0.98)",
      "text-halo-width": 2,
    },
  },
  {
    id: "Landmark_shop_am_pm",
    type: "symbol",
    source: "5ec4d27c8c861c736024026f",
    "source-layer": "LandmarkPoint",
    filter: ["all", ["==", "sub_type_code", 1113], ["==", "sub_group", 2]],
    layout: {
      "icon-anchor": "center",
      "icon-offset": {
        stops: [
          [15, [0, -250]],
          [20, [0, -300]],
        ],
      },
      "icon-size": {
        stops: [
          [10, 0.02],
          [15, 0.02],
          [20, 0.035],
        ],
      },
      "symbol-spacing": 20,
      "text-allow-overlap": false,
      "text-field": "",
      "text-font": ["Kanit"],
      "text-ignore-placement": false,
      "text-justify": "center",
      "text-max-width": 20,
      "text-size": {
        stops: [
          [10, 6],
          [15, 9],
          [20, 11],
        ],
      },
      visibility: "visible",
    },
    paint: {
      "text-color": "rgba(86, 81, 81, 0.97)",
      "text-halo-blur": 1,
      "text-halo-color": "rgba(243, 240, 240, 0.98)",
      "text-halo-width": 2,
    },
  },
  {
    id: "Landmark_shop_11_77",
    type: "symbol",
    source: "5ec4d27c8c861c736024026f",
    "source-layer": "LandmarkPoint",
    filter: ["all", ["==", "sub_type_code", 1113], ["==", "sub_group", 1]],
    layout: {
      "icon-anchor": "center",
      "icon-image": "shop_7_11",
      "icon-offset": {
        stops: [
          [15, [0, -300]],
          [20, [0, -350]],
        ],
      },
      "icon-size": {
        stops: [
          [10, 0.02],
          [15, 0.02],
          [20, 0.035],
        ],
      },
      "symbol-spacing": 20,
      "text-allow-overlap": false,
      "text-field": "{name}",
      "text-font": ["Kanit"],
      "text-ignore-placement": false,
      "text-justify": "center",
      "text-max-width": 20,
      "text-size": {
        stops: [
          [10, 6],
          [15, 9],
          [20, 11],
        ],
      },
      visibility: "visible",
    },
    paint: {
      "text-color": "rgba(86, 81, 81, 0.97)",
      "text-halo-blur": 1,
      "text-halo-color": "rgba(243, 240, 240, 0.98)",
      "text-halo-width": 2,
    },
  },
  {
    id: "Landmark_shop_store",
    type: "symbol",
    source: "5ec4d27c8c861c736024026f",
    "source-layer": "LandmarkPoint",
    filter: ["all", ["==", "sub_type_code", 1113], ["==", "sub_group", 0]],
    layout: {
      "icon-anchor": "center",
      "icon-image": "shop_store",
      "icon-offset": {
        stops: [
          [15, [0, -100]],
          [20, [0, -80]],
        ],
      },
      "icon-size": {
        stops: [
          [10, 0.1],
          [15, 0.12],
          [20, 0.18],
        ],
      },
      "symbol-spacing": 20,
      "text-allow-overlap": false,
      "text-field": "{name}",
      "text-font": ["Kanit"],
      "text-ignore-placement": false,
      "text-justify": "center",
      "text-max-width": 20,
      "text-size": {
        stops: [
          [10, 6],
          [15, 9],
          [20, 11],
        ],
      },
      visibility: "visible",
    },
    paint: {
      "icon-opacity": 0.5,
      "text-color": "rgba(86, 81, 81, 0.97)",
      "text-halo-blur": 1,
      "text-halo-color": "rgba(243, 240, 240, 0.98)",
      "text-halo-width": 2,
    },
  },
  {
    id: "Landmark_department_store",
    type: "symbol",
    source: "5ec4d27c8c861c736024026f",
    "source-layer": "LandmarkPoint",
    filter: ["all", ["==", "sub_type_code", 1112], ["==", "sub_group", 0]],
    layout: {
      "icon-anchor": "center",
      "icon-image": "department_store",
      "icon-offset": {
        stops: [
          [15, [0, -100]],
          [20, [0, -80]],
        ],
      },
      "icon-size": {
        stops: [
          [10, 0.1],
          [15, 0.12],
          [20, 0.18],
        ],
      },
      "symbol-spacing": 20,
      "text-allow-overlap": false,
      "text-field": "{name}",
      "text-font": ["Kanit"],
      "text-ignore-placement": false,
      "text-justify": "center",
      "text-max-width": 20,
      "text-size": {
        stops: [
          [10, 6],
          [15, 9],
          [20, 11],
        ],
      },
      visibility: "visible",
    },
    paint: {
      "icon-opacity": 0.5,
      "text-color": "rgba(86, 81, 81, 0.97)",
      "text-halo-blur": 1,
      "text-halo-color": "rgba(243, 240, 240, 0.98)",
      "text-halo-width": 2,
    },
  },
  {
    id: "Landmark_park",
    type: "symbol",
    source: "5ec4d27c8c861c736024026f",
    "source-layer": "LandmarkPoint",
    filter: ["all", ["==", "sub_type_code", 1111], ["==", "sub_group", 4]],
    layout: {
      "icon-anchor": "center",
      "icon-image": {
        stops: [
          [6, "park-11"],
          [10, "park-15"],
        ],
      },
      "icon-offset": {
        stops: [
          [15, [0, -10]],
          [20, [0, -15]],
        ],
      },
      "icon-size": {
        stops: [
          [10, 1],
          [15, 1],
          [20, 1],
        ],
      },
      "symbol-spacing": 20,
      "text-allow-overlap": false,
      "text-field": "{name}",
      "text-font": ["Kanit"],
      "text-ignore-placement": false,
      "text-justify": "center",
      "text-max-width": 20,
      "text-size": {
        stops: [
          [10, 6],
          [15, 9],
          [20, 11],
        ],
      },
      visibility: "visible",
    },
    paint: {
      "icon-opacity": 0.5,
      "text-color": "rgba(86, 81, 81, 0.97)",
      "text-halo-blur": 1,
      "text-halo-color": "rgba(243, 240, 240, 0.98)",
      "text-halo-width": 2,
    },
  },
  {
    id: "Landmark_cinema",
    type: "symbol",
    source: "5ec4d27c8c861c736024026f",
    "source-layer": "LandmarkPoint",
    filter: ["all", ["==", "sub_type_code", 1111], ["==", "sub_group", 3]],
    layout: {
      "icon-anchor": "center",
      "icon-image": {
        stops: [
          [6, "cinema-11"],
          [10, "cinema-15"],
        ],
      },
      "icon-offset": {
        stops: [
          [15, [0, -10]],
          [20, [0, -15]],
        ],
      },
      "icon-size": {
        stops: [
          [10, 1],
          [15, 1],
          [20, 1],
        ],
      },
      "symbol-spacing": 20,
      "text-allow-overlap": false,
      "text-field": "{name}",
      "text-font": ["Kanit"],
      "text-ignore-placement": false,
      "text-justify": "center",
      "text-max-width": 20,
      "text-size": {
        stops: [
          [10, 6],
          [15, 9],
          [20, 11],
        ],
      },
      visibility: "visible",
    },
    paint: {
      "icon-opacity": 0.5,
      "text-color": "rgba(86, 81, 81, 0.97)",
      "text-halo-blur": 1,
      "text-halo-color": "rgba(243, 240, 240, 0.98)",
      "text-halo-width": 2,
    },
  },
  {
    id: "Landmark_tourist_place",
    type: "symbol",
    source: "5ec4d27c8c861c736024026f",
    "source-layer": "LandmarkPoint",
    filter: ["all", ["==", "sub_type_code", 1111], ["==", "sub_group", 2]],
    layout: {
      "icon-anchor": "center",
      "icon-image": "tourist_place",
      "icon-offset": {
        stops: [
          [15, [0, -100]],
          [20, [0, -80]],
        ],
      },
      "icon-size": {
        stops: [
          [10, 0.1],
          [15, 0.12],
          [20, 0.2],
        ],
      },
      "symbol-spacing": 20,
      "text-allow-overlap": false,
      "text-field": "{name}",
      "text-font": ["Kanit"],
      "text-ignore-placement": false,
      "text-justify": "center",
      "text-max-width": 20,
      "text-size": {
        stops: [
          [10, 6],
          [15, 9],
          [20, 11],
        ],
      },
      visibility: "visible",
    },
    paint: {
      "icon-opacity": 0.5,
      "text-color": "rgba(86, 81, 81, 0.97)",
      "text-halo-blur": 1,
      "text-halo-color": "rgba(243, 240, 240, 0.98)",
      "text-halo-width": 2,
    },
  },
  {
    id: "Landmark_golf",
    type: "symbol",
    source: "5ec4d27c8c861c736024026f",
    "source-layer": "LandmarkPoint",
    filter: ["all", ["==", "sub_type_code", 1111], ["==", "sub_group", 1]],
    layout: {
      "icon-anchor": "center",
      "icon-image": {
        stops: [
          [15, "golf-11"],
          [20, "golf-15"],
        ],
      },
      "icon-offset": {
        stops: [
          [15, [0, -10]],
          [20, [0, -12]],
        ],
      },
      "icon-size": {
        stops: [
          [10, 1],
          [15, 1],
          [20, 1],
        ],
      },
      "symbol-spacing": 20,
      "text-allow-overlap": false,
      "text-field": "{name}",
      "text-font": ["Kanit"],
      "text-ignore-placement": false,
      "text-justify": "center",
      "text-max-width": 20,
      "text-size": {
        stops: [
          [10, 6],
          [15, 9],
          [20, 11],
        ],
      },
      visibility: "visible",
    },
    paint: {
      "icon-opacity": 0.5,
      "text-color": "rgba(86, 81, 81, 0.97)",
      "text-halo-blur": 1,
      "text-halo-color": "rgba(243, 240, 240, 0.98)",
      "text-halo-width": 2,
    },
  },
  {
    id: "Landmark_relax_place",
    type: "symbol",
    source: "5ec4d27c8c861c736024026f",
    "source-layer": "LandmarkPoint",
    filter: ["all", ["==", "sub_type_code", 1111], ["==", "sub_group", 0]],
    layout: {
      "icon-anchor": "center",
      "icon-image": "relax_place",
      "icon-offset": {
        stops: [
          [15, [0, -100]],
          [20, [0, -80]],
        ],
      },
      "icon-size": {
        stops: [
          [10, 0.1],
          [15, 0.15],
          [20, 0.2],
        ],
      },
      "symbol-spacing": 20,
      "text-allow-overlap": false,
      "text-field": "{name}",
      "text-font": ["Kanit"],
      "text-ignore-placement": false,
      "text-justify": "center",
      "text-max-width": 20,
      "text-size": {
        stops: [
          [10, 6],
          [15, 9],
          [20, 11],
        ],
      },
      visibility: "visible",
    },
    paint: {
      "icon-opacity": 0.5,
      "text-color": "rgba(86, 81, 81, 0.97)",
      "text-halo-blur": 1,
      "text-halo-color": "rgba(243, 240, 240, 0.98)",
      "text-halo-width": 2,
    },
  },
  {
    id: "Landmark_building2",
    type: "symbol",
    source: "5ec4d27c8c861c736024026f",
    "source-layer": "LandmarkPoint",
    filter: ["all", ["==", "sub_type_code", 1110], ["==", "sub_group", 2]],
    layout: {
      "icon-anchor": "center",
      "icon-offset": {
        stops: [
          [15, [0, -12]],
          [20, [0, -15]],
        ],
      },
      "icon-size": {
        stops: [
          [10, 1],
          [15, 1],
          [20, 1],
        ],
      },
      "symbol-spacing": 20,
      "text-allow-overlap": false,
      "text-field": "{name}",
      "text-font": ["Kanit"],
      "text-ignore-placement": false,
      "text-justify": "center",
      "text-max-width": 20,
      "text-size": {
        stops: [
          [10, 6],
          [15, 9],
          [20, 11],
        ],
      },
      visibility: "visible",
    },
    paint: {
      "icon-opacity": 0.5,
      "text-color": "rgba(86, 81, 81, 0.97)",
      "text-halo-blur": 1,
      "text-halo-color": "rgba(243, 240, 240, 0.98)",
      "text-halo-width": 2,
    },
  },
  {
    id: "Landmark_office",
    type: "symbol",
    source: "5ec4d27c8c861c736024026f",
    "source-layer": "LandmarkPoint",
    filter: ["all", ["==", "sub_type_code", 1110], ["==", "sub_group", 1]],
    layout: {
      "icon-anchor": "center",
      "icon-offset": {
        stops: [
          [15, [0, -10]],
          [20, [0, -15]],
        ],
      },
      "icon-size": {
        stops: [
          [10, 1],
          [15, 1],
          [20, 1],
        ],
      },
      "symbol-placement": "point",
      "symbol-spacing": 20,
      "text-allow-overlap": false,
      "text-field": "{name}",
      "text-font": ["Kanit"],
      "text-ignore-placement": false,
      "text-justify": "center",
      "text-max-width": 10,
      "text-size": {
        stops: [
          [10, 6],
          [15, 9],
          [20, 11],
        ],
      },
      visibility: "visible",
    },
    paint: {
      "icon-opacity": 0.5,
      "text-color": "rgba(86, 81, 81, 0.97)",
      "text-halo-blur": 1,
      "text-halo-color": "rgba(243, 240, 240, 0.98)",
      "text-halo-width": 2,
    },
  },
  {
    id: "Landmark_building",
    type: "symbol",
    source: "5ec4d27c8c861c736024026f",
    "source-layer": "LandmarkPoint",
    filter: ["all", ["==", "sub_type_code", 1110], ["==", "sub_group", 0]],
    layout: {
      "icon-anchor": "center",
      "icon-offset": {
        stops: [
          [15, [0, -12]],
          [20, [0, -15]],
        ],
      },
      "icon-size": 1,
      "symbol-spacing": 20,
      "text-allow-overlap": false,
      "text-field": "{name}",
      "text-font": ["Kanit"],
      "text-ignore-placement": false,
      "text-justify": "center",
      "text-max-width": 20,
      "text-size": {
        stops: [
          [10, 6],
          [15, 9],
          [20, 11],
        ],
      },
      visibility: "visible",
    },
    paint: {
      "icon-opacity": 0.5,
      "text-color": "rgba(86, 81, 81, 0.97)",
      "text-halo-blur": 1,
      "text-halo-color": "rgba(243, 240, 240, 0.98)",
      "text-halo-width": 2,
    },
  },
  {
    id: "Landmark_village",
    type: "symbol",
    source: "5ec4d27c8c861c736024026f",
    "source-layer": "LandmarkPoint",
    filter: ["all", ["==", "sub_type_code", 1109], ["==", "sub_group", 0]],
    layout: {
      "icon-anchor": "center",
      "icon-image": {
        stops: [
          [17, "village-15"],
          [20, "village-15"],
        ],
      },
      "icon-offset": [0, -12],
      "icon-size": 1,
      "symbol-spacing": 20,
      "text-allow-overlap": false,
      "text-field": "{name}",
      "text-font": ["Kanit"],
      "text-ignore-placement": false,
      "text-justify": "center",
      "text-max-width": 20,
      "text-size": {
        stops: [
          [10, 6],
          [15, 9],
          [20, 11],
        ],
      },
      visibility: "visible",
    },
    paint: {
      "icon-opacity": 0.5,
      "text-color": "rgba(86, 81, 81, 0.97)",
      "text-halo-blur": 1,
      "text-halo-color": "rgba(243, 240, 240, 0.98)",
      "text-halo-width": 2,
    },
  },
  {
    id: "Landmark_hotel",
    type: "symbol",
    source: "5ec4d27c8c861c736024026f",
    "source-layer": "LandmarkPoint",
    filter: ["all", ["==", "sub_type_code", 1108], ["==", "sub_group", 0]],
    layout: {
      "icon-anchor": "center",
      "icon-image": "hotel",
      "icon-offset": [0, -80],
      "icon-size": {
        stops: [
          [15, 0.1],
          [17, 0.12],
          [20, 0.18],
        ],
      },
      "text-allow-overlap": false,
      "text-field": "{name}",
      "text-font": ["Kanit"],
      "text-ignore-placement": false,
      "text-justify": "center",
      "text-max-width": 20,
      "text-size": {
        stops: [
          [10, 6],
          [15, 9],
          [20, 11],
        ],
      },
      visibility: "visible",
    },
    paint: {
      "icon-opacity": 0.5,
      "text-color": "rgba(86, 81, 81, 0.97)",
      "text-halo-blur": 1,
      "text-halo-color": "rgba(243, 240, 240, 0.98)",
      "text-halo-width": 2,
    },
  },
  {
    id: "Landmark_firel_station",
    type: "symbol",
    source: "5ec4d27c8c861c736024026f",
    "source-layer": "LandmarkPoint",
    filter: ["all", ["==", "sub_type_code", 1107], ["==", "sub_group", 0]],
    layout: {
      "icon-anchor": "center",
      "icon-image": "fire-station",
      "icon-offset": [0, -260],
      "icon-size": {
        stops: [
          [10, 0.03],
          [17, 0.04],
          [20, 0.05],
        ],
      },
      "text-field": "{name}",
      "text-font": ["Kanit"],
      "text-justify": "center",
      "text-max-width": 20,
      "text-size": {
        stops: [
          [10, 6],
          [15, 9],
          [20, 11],
        ],
      },
      visibility: "visible",
    },
    paint: {
      "icon-opacity": 0.5,
      "text-color": "rgba(86, 81, 81, 0.97)",
      "text-halo-blur": 1,
      "text-halo-color": "rgba(243, 240, 240, 0.98)",
      "text-halo-width": 2,
    },
  },
  {
    id: "Landmark_other_oil_station",
    type: "symbol",
    source: "5ec4d27c8c861c736024026f",
    "source-layer": "LandmarkPoint",
    filter: ["all", ["==", "sub_type_code", 1106], ["==", "sub_group", 9]],
    layout: {
      "icon-anchor": "center",
      "icon-image": "oil_station",
      "icon-offset": [0, -340],
      "icon-size": {
        stops: [
          [10, 0.02],
          [17, 0.03],
          [20, 0.04],
        ],
      },
      "text-field": "{name}",
      "text-font": ["Kanit"],
      "text-justify": "center",
      "text-max-width": 20,
      "text-size": {
        stops: [
          [10, 6],
          [15, 9],
          [20, 11],
        ],
      },
      visibility: "visible",
    },
    paint: {
      "icon-opacity": 0.5,
      "text-color": "rgba(86, 81, 81, 0.97)",
      "text-halo-blur": 1,
      "text-halo-color": "rgba(243, 240, 240, 0.98)",
      "text-halo-width": 2,
    },
  },
  {
    id: "Landmark_tpi_oil_station",
    type: "symbol",
    source: "5ec4d27c8c861c736024026f",
    "source-layer": "LandmarkPoint",
    filter: ["all", ["==", "sub_type_code", 1106], ["==", "sub_group", 8]],
    layout: {
      "icon-anchor": "center",
      "icon-offset": [0, -340],
      "icon-size": {
        stops: [
          [10, 0.02],
          [17, 0.03],
          [20, 0.04],
        ],
      },
      "text-field": "",
      "text-font": ["Kanit"],
      "text-justify": "center",
      "text-max-width": 20,
      "text-size": {
        stops: [
          [10, 6],
          [15, 9],
          [20, 11],
        ],
      },
      visibility: "visible",
    },
    paint: {
      "icon-opacity": 0.5,
      "text-color": "rgba(86, 81, 81, 0.97)",
      "text-halo-blur": 1,
      "text-halo-color": "rgba(243, 240, 240, 0.98)",
      "text-halo-width": 2,
    },
  },
  {
    id: "Landmark_petronas_oil_station",
    type: "symbol",
    source: "5ec4d27c8c861c736024026f",
    "source-layer": "LandmarkPoint",
    filter: ["all", ["==", "sub_type_code", 1106], ["==", "sub_group", 7]],
    layout: {
      "icon-anchor": "center",
      "icon-image": "petronas_oil_station",
      "icon-offset": [0, -340],
      "icon-size": {
        stops: [
          [10, 0.02],
          [17, 0.03],
          [20, 0.04],
        ],
      },
      "text-field": "{name}",
      "text-font": ["Kanit"],
      "text-justify": "center",
      "text-max-width": 20,
      "text-size": {
        stops: [
          [10, 6],
          [15, 9],
          [20, 11],
        ],
      },
      visibility: "visible",
    },
    paint: {
      "icon-opacity": 0.5,
      "text-color": "rgba(86, 81, 81, 0.97)",
      "text-halo-blur": 1,
      "text-halo-color": "rgba(243, 240, 240, 0.98)",
      "text-halo-width": 2,
    },
  },
  {
    id: "Landmark_jet_oil_station",
    type: "symbol",
    source: "5ec4d27c8c861c736024026f",
    "source-layer": "LandmarkPoint",
    filter: ["all", ["==", "sub_type_code", 1106], ["==", "sub_group", 6]],
    layout: {
      "icon-anchor": "center",
      "icon-offset": [0, -340],
      "icon-size": {
        stops: [
          [10, 0.02],
          [17, 0.03],
          [20, 0.04],
        ],
      },
      "text-field": "",
      "text-font": ["Kanit"],
      "text-justify": "center",
      "text-max-width": 20,
      "text-size": {
        stops: [
          [10, 6],
          [15, 9],
          [20, 11],
        ],
      },
      visibility: "visible",
    },
    paint: {
      "icon-opacity": 0.5,
      "text-color": "rgba(86, 81, 81, 0.97)",
      "text-halo-blur": 1,
      "text-halo-color": "rgba(243, 240, 240, 0.98)",
      "text-halo-width": 2,
    },
  },
  {
    id: "Landmark_esso_oil_station",
    type: "symbol",
    source: "5ec4d27c8c861c736024026f",
    "source-layer": "LandmarkPoint",
    filter: ["all", ["==", "sub_type_code", 1106], ["==", "sub_group", 5]],
    layout: {
      "icon-anchor": "center",
      "icon-image": "esso_oil_station",
      "icon-offset": [0, -340],
      "icon-size": {
        stops: [
          [10, 0.02],
          [17, 0.03],
          [20, 0.04],
        ],
      },
      "text-field": "{name}",
      "text-font": ["Kanit"],
      "text-justify": "center",
      "text-max-width": 20,
      "text-size": {
        stops: [
          [10, 6],
          [15, 9],
          [20, 11],
        ],
      },
      visibility: "visible",
    },
    paint: {
      "icon-opacity": 0.5,
      "text-color": "rgba(86, 81, 81, 0.97)",
      "text-halo-blur": 1,
      "text-halo-color": "rgba(243, 240, 240, 0.98)",
      "text-halo-width": 2,
    },
  },
  {
    id: "Landmark_shell_oil_station",
    type: "symbol",
    source: "5ec4d27c8c861c736024026f",
    "source-layer": "LandmarkPoint",
    filter: ["all", ["==", "sub_type_code", 1106], ["==", "sub_group", 4]],
    layout: {
      "icon-anchor": "center",
      "icon-image": "shell_oil_station",
      "icon-offset": [0, -340],
      "icon-size": {
        stops: [
          [10, 0.02],
          [17, 0.03],
          [20, 0.04],
        ],
      },
      "text-field": "{name}",
      "text-font": ["Kanit"],
      "text-justify": "center",
      "text-max-width": 20,
      "text-size": {
        stops: [
          [10, 6],
          [15, 9],
          [20, 11],
        ],
      },
      visibility: "visible",
    },
    paint: {
      "icon-opacity": 0.5,
      "text-color": "rgba(86, 81, 81, 0.97)",
      "text-halo-blur": 1,
      "text-halo-color": "rgba(243, 240, 240, 0.98)",
      "text-halo-width": 2,
    },
  },
  {
    id: "Landmark_cartex_oil_station",
    type: "symbol",
    source: "5ec4d27c8c861c736024026f",
    "source-layer": "LandmarkPoint",
    filter: ["all", ["==", "sub_type_code", 1106], ["==", "sub_group", 1]],
    layout: {
      "icon-anchor": "center",
      "icon-image": "cartex_oil_station",
      "icon-offset": [0, -340],
      "icon-size": {
        stops: [
          [10, 0.02],
          [17, 0.03],
          [20, 0.04],
        ],
      },
      "text-field": "{name}",
      "text-font": ["Kanit"],
      "text-justify": "center",
      "text-max-width": 20,
      "text-size": {
        stops: [
          [10, 6],
          [15, 9],
          [20, 11],
        ],
      },
      visibility: "visible",
    },
    paint: {
      "icon-opacity": 0.5,
      "text-color": "rgba(86, 81, 81, 0.97)",
      "text-halo-blur": 1,
      "text-halo-color": "rgba(243, 240, 240, 0.98)",
      "text-halo-width": 2,
    },
  },
  {
    id: "Landmark_bangjak_oil_station",
    type: "symbol",
    source: "5ec4d27c8c861c736024026f",
    "source-layer": "LandmarkPoint",
    filter: ["all", ["==", "sub_type_code", 1106], ["==", "sub_group", 3]],
    layout: {
      "icon-anchor": "center",
      "icon-image": "bangjak_oil_station",
      "icon-offset": [0, -340],
      "icon-size": {
        stops: [
          [10, 0.02],
          [17, 0.03],
          [20, 0.04],
        ],
      },
      "text-field": "{name}",
      "text-font": ["Kanit"],
      "text-justify": "center",
      "text-max-width": 20,
      "text-size": {
        stops: [
          [10, 6],
          [15, 9],
          [20, 11],
        ],
      },
      visibility: "visible",
    },
    paint: {
      "icon-opacity": 0.5,
      "text-color": "rgba(86, 81, 81, 0.97)",
      "text-halo-blur": 1,
      "text-halo-color": "rgba(243, 240, 240, 0.98)",
      "text-halo-width": 2,
    },
  },
  {
    id: "Landmark_ptt_oil_station",
    type: "symbol",
    source: "5ec4d27c8c861c736024026f",
    "source-layer": "LandmarkPoint",
    filter: ["all", ["==", "sub_type_code", 1106], ["==", "sub_group", 2]],
    layout: {
      "icon-anchor": "center",
      "icon-image": "ptt_oil_station",
      "icon-offset": [0, -340],
      "icon-size": {
        stops: [
          [10, 0.02],
          [17, 0.03],
          [20, 0.04],
        ],
      },
      "text-field": "{name}",
      "text-font": ["Kanit"],
      "text-justify": "center",
      "text-max-width": 20,
      "text-size": {
        stops: [
          [10, 6],
          [15, 9],
          [20, 11],
        ],
      },
      visibility: "visible",
    },
    paint: {
      "icon-opacity": 0.5,
      "text-color": "rgba(86, 81, 81, 0.97)",
      "text-halo-blur": 1,
      "text-halo-color": "rgba(243, 240, 240, 0.98)",
      "text-halo-width": 2,
    },
  },
  {
    id: "Landmark_oil_staion",
    type: "symbol",
    source: "5ec4d27c8c861c736024026f",
    "source-layer": "LandmarkPoint",
    filter: ["all", ["==", "sub_type_code", 1106], ["==", "sub_group", 0]],
    layout: {
      "icon-anchor": "center",
      "icon-image": "oil_station",
      "icon-offset": [0, -340],
      "icon-size": {
        stops: [
          [10, 0.02],
          [17, 0.03],
          [20, 0.04],
        ],
      },
      "text-field": "{name}",
      "text-font": ["Kanit"],
      "text-justify": "center",
      "text-max-width": 20,
      "text-size": {
        stops: [
          [10, 6],
          [15, 9],
          [20, 11],
        ],
      },
      visibility: "visible",
    },
    paint: {
      "icon-opacity": 0.5,
      "text-color": "rgba(86, 81, 81, 0.97)",
      "text-halo-blur": 1,
      "text-halo-color": "rgba(243, 240, 240, 0.98)",
      "text-halo-width": 2,
    },
  },
  {
    id: "Landmark_restaurant",
    type: "symbol",
    source: "5ec4d27c8c861c736024026f",
    "source-layer": "LandmarkPoint",
    filter: ["all", ["==", "sub_type_code", 1105], ["==", "sub_group", 0]],
    layout: {
      "icon-anchor": "center",
      "icon-image": "restaurant",
      "icon-offset": [0, -55],
      "icon-size": {
        stops: [
          [10, 0.1],
          [15, 0.2],
          [20, 0.2],
        ],
      },
      "text-field": "{name}",
      "text-font": ["Kanit"],
      "text-justify": "center",
      "text-max-width": 20,
      "text-size": {
        stops: [
          [10, 6],
          [15, 9],
          [20, 11],
        ],
      },
      visibility: "visible",
    },
    paint: {
      "icon-opacity": 0.5,
      "text-color": "rgba(86, 81, 81, 0.97)",
      "text-halo-blur": 1,
      "text-halo-color": "rgba(243, 240, 240, 0.98)",
      "text-halo-width": 2,
    },
  },
  {
    id: "Landmark_other_bank",
    type: "symbol",
    source: "5ec4d27c8c861c736024026f",
    "source-layer": "LandmarkPoint",
    filter: ["all", ["==", "sub_type_code", 1104], ["==", "sub_group", 20]],
    layout: {
      "icon-anchor": "bottom",
      "icon-image": {
        stops: [
          [15, "bank-11"],
          [20, "bank-12"],
        ],
      },
      "icon-offset": [0, -2],
      "icon-size": 1,
      "text-field": "{name}",
      "text-font": ["Kanit"],
      "text-justify": "center",
      "text-max-width": 20,
      "text-size": {
        stops: [
          [10, 6],
          [15, 9],
          [20, 11],
        ],
      },
      visibility: "visible",
    },
    paint: {
      "icon-opacity": 0.5,
      "text-color": "rgba(86, 81, 81, 0.97)",
      "text-halo-blur": 1,
      "text-halo-color": "rgba(243, 240, 240, 0.98)",
      "text-halo-width": 2,
    },
  },
  {
    id: "Landmark_bank_of_thai",
    type: "symbol",
    source: "5ec4d27c8c861c736024026f",
    "source-layer": "LandmarkPoint",
    filter: ["all", ["==", "sub_type_code", 1104], ["==", "sub_group", 19]],
    layout: {
      "icon-anchor": "bottom",
      "icon-image": "bank_of_thailand",
      "icon-offset": [0, -100],
      "icon-size": {
        stops: [
          [15, 0.03],
          [18, 0.03],
          [20, 0.04],
        ],
      },
      "text-field": "{name}",
      "text-font": ["Kanit"],
      "text-justify": "center",
      "text-max-width": 20,
      "text-size": {
        stops: [
          [10, 6],
          [15, 9],
          [20, 11],
        ],
      },
      visibility: "visible",
    },
    paint: {
      "icon-opacity": 0.5,
      "text-color": "rgba(86, 81, 81, 0.97)",
      "text-halo-blur": 1,
      "text-halo-color": "rgba(243, 240, 240, 0.98)",
      "text-halo-width": 2,
    },
  },
  {
    id: "Landmark_i_bank",
    type: "symbol",
    source: "5ec4d27c8c861c736024026f",
    "source-layer": "LandmarkPoint",
    filter: ["all", ["==", "sub_type_code", 1104], ["==", "sub_group", 18]],
    layout: {
      "icon-anchor": "bottom",
      "icon-image": "i_bank",
      "icon-offset": [0, -100],
      "icon-size": {
        stops: [
          [15, 0.03],
          [18, 0.03],
          [20, 0.04],
        ],
      },
      "text-field": "{name}",
      "text-font": ["Kanit"],
      "text-justify": "center",
      "text-max-width": 20,
      "text-size": {
        stops: [
          [10, 6],
          [15, 9],
          [20, 11],
        ],
      },
      visibility: "visible",
    },
    paint: {
      "icon-opacity": 0.5,
      "text-color": "rgba(86, 81, 81, 0.97)",
      "text-halo-blur": 1,
      "text-halo-color": "rgba(243, 240, 240, 0.98)",
      "text-halo-width": 2,
    },
  },
  {
    id: "Landmark_sme_bank",
    type: "symbol",
    source: "5ec4d27c8c861c736024026f",
    "source-layer": "LandmarkPoint",
    filter: ["all", ["==", "sub_type_code", 1104], ["==", "sub_group", 17]],
    layout: {
      "icon-anchor": "bottom",
      "icon-image": "sme_bank",
      "icon-offset": [0, -100],
      "icon-size": {
        stops: [
          [15, 0.03],
          [18, 0.04],
          [20, 0.05],
        ],
      },
      "text-field": "{name}",
      "text-font": ["Kanit"],
      "text-justify": "center",
      "text-max-width": 20,
      "text-size": {
        stops: [
          [10, 6],
          [15, 9],
          [20, 11],
        ],
      },
      visibility: "visible",
    },
    paint: {
      "icon-opacity": 0.5,
      "text-color": "rgba(86, 81, 81, 0.97)",
      "text-halo-blur": 1,
      "text-halo-color": "rgba(243, 240, 240, 0.98)",
      "text-halo-width": 2,
    },
  },
  {
    id: "Landmark_exim_bank",
    type: "symbol",
    source: "5ec4d27c8c861c736024026f",
    "source-layer": "LandmarkPoint",
    filter: ["all", ["==", "sub_type_code", 1104], ["==", "sub_group", 16]],
    layout: {
      "icon-anchor": "bottom",
      "icon-image": "exim_bank",
      "icon-offset": [0, -100],
      "icon-size": {
        stops: [
          [15, 0.03],
          [18, 0.04],
          [20, 0.05],
        ],
      },
      "text-field": "{name}",
      "text-font": ["Kanit"],
      "text-justify": "center",
      "text-max-width": 20,
      "text-size": {
        stops: [
          [10, 6],
          [15, 9],
          [20, 11],
        ],
      },
      visibility: "visible",
    },
    paint: {
      "icon-opacity": 0.5,
      "text-color": "rgba(86, 81, 81, 0.97)",
      "text-halo-blur": 1,
      "text-halo-color": "rgba(243, 240, 240, 0.98)",
      "text-halo-width": 2,
    },
  },
  {
    id: "Landmark_gsb",
    type: "symbol",
    source: "5ec4d27c8c861c736024026f",
    "source-layer": "LandmarkPoint",
    filter: ["all", ["==", "sub_type_code", 1104], ["==", "sub_group", 15]],
    layout: {
      "icon-anchor": "bottom",
      "icon-image": "gsb",
      "icon-offset": [0, -200],
      "icon-size": {
        stops: [
          [15, 0.02],
          [18, 0.03],
          [20, 0.04],
        ],
      },
      "text-field": "{name}",
      "text-font": ["Kanit"],
      "text-justify": "center",
      "text-max-width": 20,
      "text-size": {
        stops: [
          [10, 6],
          [15, 9],
          [20, 11],
        ],
      },
      visibility: "visible",
    },
    paint: {
      "icon-opacity": 0.5,
      "text-color": "rgba(86, 81, 81, 0.97)",
      "text-halo-blur": 1,
      "text-halo-color": "rgba(243, 240, 240, 0.98)",
      "text-halo-width": 2,
    },
  },
  {
    id: "Landmark_gh_bank",
    type: "symbol",
    source: "5ec4d27c8c861c736024026f",
    "source-layer": "LandmarkPoint",
    filter: ["all", ["==", "sub_type_code", 1104], ["==", "sub_group", 14]],
    layout: {
      "icon-anchor": "bottom",
      "icon-image": "gh_bank",
      "icon-offset": [0, -200],
      "icon-size": {
        stops: [
          [15, 0.02],
          [18, 0.03],
          [20, 0.04],
        ],
      },
      "text-field": "{name}",
      "text-font": ["Kanit"],
      "text-justify": "center",
      "text-max-width": 20,
      "text-size": {
        stops: [
          [10, 6],
          [15, 9],
          [20, 11],
        ],
      },
      visibility: "visible",
    },
    paint: {
      "icon-opacity": 0.5,
      "text-color": "rgba(86, 81, 81, 0.97)",
      "text-halo-blur": 1,
      "text-halo-color": "rgba(243, 240, 240, 0.98)",
      "text-halo-width": 2,
    },
  },
  {
    id: "Landmark_baac_bank",
    type: "symbol",
    source: "5ec4d27c8c861c736024026f",
    "source-layer": "LandmarkPoint",
    filter: ["all", ["==", "sub_type_code", 1104], ["==", "sub_group", 13]],
    layout: {
      "icon-anchor": "bottom",
      "icon-image": "baac_bank",
      "icon-offset": [0, -200],
      "icon-size": {
        stops: [
          [15, 0.02],
          [18, 0.03],
          [20, 0.04],
        ],
      },
      "text-field": "{name}",
      "text-font": ["Kanit"],
      "text-justify": "center",
      "text-max-width": 20,
      "text-size": {
        stops: [
          [10, 6],
          [15, 9],
          [20, 11],
        ],
      },
      visibility: "visible",
    },
    paint: {
      "icon-opacity": 0.5,
      "text-color": "rgba(86, 81, 81, 0.97)",
      "text-halo-blur": 1,
      "text-halo-color": "rgba(243, 240, 240, 0.98)",
      "text-halo-width": 2,
    },
  },
  {
    id: "Landmark_thanachart_bank",
    type: "symbol",
    source: "5ec4d27c8c861c736024026f",
    "source-layer": "LandmarkPoint",
    filter: ["all", ["==", "sub_type_code", 1104], ["==", "sub_group", 12]],
    layout: {
      "icon-anchor": "bottom",
      "icon-image": "thanachart_bank",
      "icon-offset": [0, -200],
      "icon-size": {
        stops: [
          [15, 0.02],
          [18, 0.03],
          [20, 0.04],
        ],
      },
      "text-field": "{name}",
      "text-font": ["Kanit"],
      "text-justify": "center",
      "text-max-width": 20,
      "text-size": {
        stops: [
          [10, 6],
          [15, 9],
          [20, 11],
        ],
      },
      visibility: "visible",
    },
    paint: {
      "icon-opacity": 0.5,
      "text-color": "rgba(86, 81, 81, 0.97)",
      "text-halo-blur": 1,
      "text-halo-color": "rgba(243, 240, 240, 0.98)",
      "text-halo-width": 2,
    },
  },
  {
    id: "Landmark_asia_bank",
    type: "symbol",
    source: "5ec4d27c8c861c736024026f",
    "source-layer": "LandmarkPoint",
    filter: ["all", ["==", "sub_type_code", 1104], ["==", "sub_group", 11]],
    layout: {
      "icon-anchor": "bottom",
      "icon-offset": [0, -200],
      "icon-size": {
        stops: [
          [15, 0.02],
          [18, 0.03],
          [20, 0.04],
        ],
      },
      "text-field": "",
      "text-font": ["Kanit"],
      "text-justify": "center",
      "text-max-width": 20,
      "text-size": {
        stops: [
          [10, 6],
          [15, 9],
          [20, 11],
        ],
      },
      visibility: "visible",
    },
    paint: {
      "icon-opacity": 0.5,
      "text-color": "rgba(86, 81, 81, 0.97)",
      "text-halo-blur": 1,
      "text-halo-color": "rgba(243, 240, 240, 0.98)",
      "text-halo-width": 2,
    },
  },
  {
    id: "Landmark_standard_bank",
    type: "symbol",
    source: "5ec4d27c8c861c736024026f",
    "source-layer": "LandmarkPoint",
    filter: ["all", ["==", "sub_type_code", 1104], ["==", "sub_group", 10]],
    layout: {
      "icon-anchor": "bottom",
      "icon-image": "standard_bank",
      "icon-offset": [0, -200],
      "icon-size": {
        stops: [
          [15, 0.02],
          [18, 0.03],
          [20, 0.04],
        ],
      },
      "text-field": "{name}",
      "text-font": ["Kanit"],
      "text-justify": "center",
      "text-max-width": 20,
      "text-size": {
        stops: [
          [10, 6],
          [15, 9],
          [20, 11],
        ],
      },
      visibility: "visible",
    },
    paint: {
      "icon-opacity": 0.5,
      "text-color": "rgba(86, 81, 81, 0.97)",
      "text-halo-blur": 1,
      "text-halo-color": "rgba(243, 240, 240, 0.98)",
      "text-halo-width": 2,
    },
  },
  {
    id: "Landmark_uob_bank",
    type: "symbol",
    source: "5ec4d27c8c861c736024026f",
    "source-layer": "LandmarkPoint",
    filter: ["all", ["==", "sub_type_code", 1104], ["==", "sub_group", 9]],
    layout: {
      "icon-anchor": "bottom",
      "icon-image": "UOB_bank",
      "icon-offset": [0, -200],
      "icon-size": {
        stops: [
          [15, 0.02],
          [18, 0.03],
          [20, 0.04],
        ],
      },
      "text-field": "{name}",
      "text-font": ["Kanit"],
      "text-justify": "center",
      "text-max-width": 20,
      "text-size": {
        stops: [
          [10, 6],
          [15, 9],
          [20, 11],
        ],
      },
      visibility: "visible",
    },
    paint: {
      "icon-opacity": 0.5,
      "text-color": "rgba(86, 81, 81, 0.97)",
      "text-halo-blur": 1,
      "text-halo-color": "rgba(243, 240, 240, 0.98)",
      "text-halo-width": 2,
    },
  },
  {
    id: "Landmark_nakhon_luang_thai_bank",
    type: "symbol",
    source: "5ec4d27c8c861c736024026f",
    "source-layer": "LandmarkPoint",
    filter: ["all", ["==", "sub_type_code", 1104], ["==", "sub_group", 8]],
    layout: {
      "icon-anchor": "bottom",
      "icon-offset": [0, -200],
      "icon-size": {
        stops: [
          [15, 0.02],
          [18, 0.03],
          [20, 0.04],
        ],
      },
      "text-field": "",
      "text-font": ["Kanit"],
      "text-justify": "center",
      "text-max-width": 20,
      "text-size": {
        stops: [
          [10, 6],
          [15, 9],
          [20, 11],
        ],
      },
      visibility: "visible",
    },
    paint: {
      "icon-opacity": 0.5,
      "text-color": "rgba(86, 81, 81, 0.97)",
      "text-halo-blur": 1,
      "text-halo-color": "rgba(243, 240, 240, 0.98)",
      "text-halo-width": 2,
    },
  },
  {
    id: "Landmark_scb_bank",
    type: "symbol",
    source: "5ec4d27c8c861c736024026f",
    "source-layer": "LandmarkPoint",
    filter: ["all", ["==", "sub_type_code", 1104], ["==", "sub_group", 7]],
    layout: {
      "icon-anchor": "bottom",
      "icon-image": "scb_bank",
      "icon-offset": [0, -200],
      "icon-size": {
        stops: [
          [15, 0.02],
          [18, 0.03],
          [20, 0.04],
        ],
      },
      "text-field": "{name}",
      "text-font": ["Kanit"],
      "text-justify": "center",
      "text-max-width": 20,
      "text-size": {
        stops: [
          [10, 6],
          [15, 9],
          [20, 11],
        ],
      },
      visibility: "visible",
    },
    paint: {
      "icon-opacity": 0.5,
      "text-color": "rgba(86, 81, 81, 0.97)",
      "text-halo-blur": 1,
      "text-halo-color": "rgba(243, 240, 240, 0.98)",
      "text-halo-width": 2,
    },
  },
  {
    id: "Landmark_thai_bank",
    type: "symbol",
    source: "5ec4d27c8c861c736024026f",
    "source-layer": "LandmarkPoint",
    filter: ["all", ["==", "sub_type_code", 1104], ["==", "sub_group", 6]],
    layout: {
      "icon-anchor": "bottom",
      "icon-image": "thai_bank",
      "icon-offset": [0, -200],
      "icon-size": {
        stops: [
          [15, 0.02],
          [18, 0.03],
          [20, 0.04],
        ],
      },
      "text-field": "{name}",
      "text-font": ["Kanit"],
      "text-justify": "center",
      "text-max-width": 20,
      "text-size": {
        stops: [
          [10, 6],
          [15, 9],
          [20, 11],
        ],
      },
      visibility: "visible",
    },
    paint: {
      "icon-opacity": 0.5,
      "text-color": "rgba(86, 81, 81, 0.97)",
      "text-halo-blur": 1,
      "text-halo-color": "rgba(243, 240, 240, 0.98)",
      "text-halo-width": 2,
    },
  },
  {
    id: "Landmark_tmb_bank",
    type: "symbol",
    source: "5ec4d27c8c861c736024026f",
    "source-layer": "LandmarkPoint",
    filter: ["all", ["==", "sub_type_code", 1104], ["==", "sub_group", 5]],
    layout: {
      "icon-anchor": "bottom",
      "icon-image": "tmb_bank",
      "icon-offset": [0, -200],
      "icon-size": {
        stops: [
          [15, 0.02],
          [18, 0.03],
          [20, 0.04],
        ],
      },
      "text-field": "{name}",
      "text-font": ["Kanit"],
      "text-justify": "center",
      "text-max-width": 20,
      "text-size": {
        stops: [
          [10, 6],
          [15, 9],
          [20, 11],
        ],
      },
      visibility: "visible",
    },
    paint: {
      "icon-opacity": 0.5,
      "text-color": "rgba(86, 81, 81, 0.97)",
      "text-halo-blur": 1,
      "text-halo-color": "rgba(243, 240, 240, 0.98)",
      "text-halo-width": 2,
    },
  },
  {
    id: "Landmark_k_bank",
    type: "symbol",
    source: "5ec4d27c8c861c736024026f",
    "source-layer": "LandmarkPoint",
    filter: ["all", ["==", "sub_type_code", 1104], ["==", "sub_group", 4]],
    layout: {
      "icon-anchor": "bottom",
      "icon-image": "k_bank",
      "icon-offset": [0, -200],
      "icon-size": {
        stops: [
          [15, 0.02],
          [18, 0.03],
          [20, 0.04],
        ],
      },
      "text-field": "{name}",
      "text-font": ["Kanit"],
      "text-justify": "center",
      "text-max-width": 20,
      "text-size": {
        stops: [
          [10, 6],
          [15, 9],
          [20, 11],
        ],
      },
      visibility: "visible",
    },
    paint: {
      "icon-opacity": 0.5,
      "text-color": "rgba(86, 81, 81, 0.97)",
      "text-halo-blur": 1,
      "text-halo-color": "rgba(243, 240, 240, 0.98)",
      "text-halo-width": 2,
    },
  },
  {
    id: "Landmark_krungsri_bank",
    type: "symbol",
    source: "5ec4d27c8c861c736024026f",
    "source-layer": "LandmarkPoint",
    filter: ["all", ["==", "sub_type_code", 1104], ["==", "sub_group", 3]],
    layout: {
      "icon-anchor": "bottom",
      "icon-image": "krungsri_bank",
      "icon-offset": [0, -200],
      "icon-size": {
        stops: [
          [15, 0.02],
          [18, 0.03],
          [20, 0.04],
        ],
      },
      "text-field": "{name}",
      "text-font": ["Kanit"],
      "text-justify": "center",
      "text-max-width": 20,
      "text-size": {
        stops: [
          [10, 6],
          [15, 9],
          [20, 11],
        ],
      },
      visibility: "visible",
    },
    paint: {
      "icon-opacity": 0.5,
      "text-color": "rgba(86, 81, 81, 0.97)",
      "text-halo-blur": 1,
      "text-halo-color": "rgba(243, 240, 240, 0.98)",
      "text-halo-width": 2,
    },
  },
  {
    id: "Landmark_ktb_bank",
    type: "symbol",
    source: "5ec4d27c8c861c736024026f",
    "source-layer": "LandmarkPoint",
    filter: ["all", ["==", "sub_type_code", 1104], ["==", "sub_group", 2]],
    layout: {
      "icon-anchor": "bottom",
      "icon-image": "ktb_bnk",
      "icon-offset": [0, -200],
      "icon-size": {
        stops: [
          [15, 0.02],
          [18, 0.03],
          [20, 0.04],
        ],
      },
      "text-field": "{name}",
      "text-font": ["Kanit"],
      "text-justify": "center",
      "text-max-width": 20,
      "text-size": {
        stops: [
          [10, 6],
          [15, 9],
          [20, 11],
        ],
      },
      visibility: "visible",
    },
    paint: {
      "icon-opacity": 0.5,
      "text-color": "rgba(86, 81, 81, 0.97)",
      "text-halo-blur": 1,
      "text-halo-color": "rgba(243, 240, 240, 0.98)",
      "text-halo-width": 2,
    },
  },
  {
    id: "Landmark_bankkok_bank",
    type: "symbol",
    source: "5ec4d27c8c861c736024026f",
    "source-layer": "LandmarkPoint",
    filter: ["all", ["==", "sub_type_code", 1104], ["==", "sub_group", 1]],
    layout: {
      "icon-anchor": "bottom",
      "icon-image": "bankok_bank",
      "icon-offset": [0, -200],
      "icon-size": {
        stops: [
          [15, 0.02],
          [18, 0.03],
          [20, 0.04],
        ],
      },
      "text-field": "{name}",
      "text-font": ["Kanit"],
      "text-justify": "center",
      "text-max-width": 20,
      "text-size": {
        stops: [
          [10, 6],
          [15, 9],
          [20, 11],
        ],
      },
      visibility: "visible",
    },
    paint: {
      "icon-opacity": 0.5,
      "text-color": "rgba(86, 81, 81, 0.97)",
      "text-halo-blur": 1,
      "text-halo-color": "rgba(243, 240, 240, 0.98)",
      "text-halo-width": 2,
    },
  },
  {
    id: "Landmark_bank",
    type: "symbol",
    source: "5ec4d27c8c861c736024026f",
    "source-layer": "LandmarkPoint",
    filter: ["all", ["==", "sub_type_code", 1104], ["==", "sub_group", 0]],
    layout: {
      "icon-anchor": "center",
      "icon-image": {
        stops: [
          [15, "bank-11"],
          [20, "bank-15"],
        ],
      },
      "icon-offset": [0, -2],
      "icon-size": {
        stops: [
          [10, 0.5],
          [17, 1],
          [20, 1.5],
        ],
      },
      "text-field": "{name}",
      "text-font": ["Kanit"],
      "text-justify": "center",
      "text-max-width": 20,
      "text-size": {
        stops: [
          [10, 6],
          [15, 9],
          [20, 11],
        ],
      },
      visibility: "visible",
    },
    paint: {
      "icon-opacity": 0.5,
      "text-color": "rgba(86, 81, 81, 0.97)",
      "text-halo-blur": 1,
      "text-halo-color": "rgba(243, 240, 240, 0.98)",
      "text-halo-width": 2,
    },
  },
  {
    id: "Landmark_atm",
    type: "symbol",
    source: "5ec4d27c8c861c736024026f",
    "source-layer": "LandmarkPoint",
    filter: ["all", ["==", "sub_type_code", 1103], ["==", "sub_group", 0]],
    layout: {
      "icon-anchor": "center",
      "icon-image": "ATM2",
      "icon-offset": [0, -60],
      "icon-size": {
        stops: [
          [10, 0.1],
          [17, 0.1],
          [20, 0.2],
        ],
      },
      "text-field": "{name}",
      "text-font": ["Kanit"],
      "text-justify": "center",
      "text-max-width": 20,
      "text-size": {
        stops: [
          [10, 6],
          [15, 9],
          [20, 11],
        ],
      },
      visibility: "visible",
    },
    paint: {
      "icon-opacity": 0.5,
      "text-color": "rgba(86, 81, 81, 0.97)",
      "text-halo-blur": 1,
      "text-halo-color": "rgba(243, 240, 240, 0.98)",
      "text-halo-width": 2,
    },
  },
  {
    id: "Landmark_heath_station",
    type: "symbol",
    source: "5ec4d27c8c861c736024026f",
    "source-layer": "LandmarkPoint",
    filter: ["all", ["==", "sub_type_code", 1102], ["==", "sub_group", 4]],
    layout: {
      "icon-anchor": "center",
      "icon-image": {
        stops: [
          [15, "hospital-JP-11"],
          [20, "hospital-JP-15"],
        ],
      },
      "icon-offset": [0, -10],
      "icon-size": {
        stops: [
          [10, 0.5],
          [17, 1],
          [20, 1.5],
        ],
      },
      "text-field": "{name}",
      "text-font": ["Kanit"],
      "text-justify": "center",
      "text-size": {
        stops: [
          [10, 6],
          [15, 9],
          [20, 11],
        ],
      },
      visibility: "visible",
    },
    paint: {
      "icon-opacity": 0.5,
      "text-color": "rgba(86, 81, 81, 0.97)",
      "text-halo-blur": 1,
      "text-halo-color": "rgba(243, 240, 240, 0.98)",
      "text-halo-width": 2,
    },
  },
  {
    id: "Landmark_hospital_tambon",
    type: "symbol",
    source: "5ec4d27c8c861c736024026f",
    "source-layer": "LandmarkPoint",
    filter: ["all", ["==", "sub_type_code", 1102], ["==", "sub_group", 3]],
    layout: {
      "icon-anchor": "center",
      "icon-image": {
        stops: [
          [15, "hospital-JP-11"],
          [20, "hospital-JP-15"],
        ],
      },
      "icon-offset": [0, -10],
      "icon-size": {
        stops: [
          [10, 0.5],
          [17, 1],
          [20, 1.5],
        ],
      },
      "text-field": "{name}",
      "text-font": ["Kanit"],
      "text-justify": "center",
      "text-size": {
        stops: [
          [10, 6],
          [15, 9],
          [20, 11],
        ],
      },
      visibility: "visible",
    },
    paint: {
      "icon-opacity": 0.5,
      "text-color": "rgba(86, 81, 81, 0.97)",
      "text-halo-blur": 1,
      "text-halo-color": "rgba(243, 240, 240, 0.98)",
      "text-halo-width": 2,
    },
  },
  {
    id: "Landmark_public_health",
    type: "symbol",
    source: "5ec4d27c8c861c736024026f",
    "source-layer": "LandmarkPoint",
    filter: ["all", ["==", "sub_type_code", 1102], ["==", "sub_group", 2]],
    layout: {
      "icon-anchor": "center",
      "icon-image": {
        stops: [
          [15, "hospital-JP-11"],
          [20, "hospital-JP-15"],
        ],
      },
      "icon-offset": [0, -10],
      "icon-size": {
        stops: [
          [10, 0.5],
          [17, 1],
          [20, 1.5],
        ],
      },
      "symbol-avoid-edges": false,
      "symbol-spacing": 200,
      "text-field": "{name}",
      "text-font": ["Kanit"],
      "text-justify": "center",
      "text-size": {
        stops: [
          [10, 6],
          [15, 9],
          [20, 11],
        ],
      },
      visibility: "visible",
    },
    paint: {
      "icon-opacity": 0.5,
      "text-color": "rgba(86, 81, 81, 0.97)",
      "text-halo-blur": 1,
      "text-halo-color": "rgba(243, 240, 240, 0.98)",
      "text-halo-width": 2,
    },
  },
  {
    id: "Landmark_hospital",
    type: "symbol",
    source: "5ec4d27c8c861c736024026f",
    "source-layer": "LandmarkPoint",
    filter: ["all", ["==", "sub_type_code", 1102], ["==", "sub_group", 1]],
    layout: {
      "icon-anchor": "center",
      "icon-image": {
        stops: [
          [15, "hospital-JP-11"],
          [20, "hospital-JP-15"],
        ],
      },
      "icon-offset": [0, -10],
      "icon-size": {
        stops: [
          [10, 0.5],
          [17, 1],
          [20, 1.5],
        ],
      },
      "text-field": "{name}",
      "text-font": ["Kanit"],
      "text-justify": "center",
      "text-max-width": 20,
      "text-pitch-alignment": "auto",
      "text-rotation-alignment": "auto",
      "text-size": {
        stops: [
          [10, 6],
          [15, 9],
          [20, 11],
        ],
      },
      visibility: "visible",
    },
    paint: {
      "icon-opacity": 0.5,
      "text-color": "rgba(86, 81, 81, 0.97)",
      "text-halo-blur": 1,
      "text-halo-color": "rgba(243, 240, 240, 0.98)",
      "text-halo-width": 2,
    },
  },
  {
    id: "Landmark_heathcenter",
    type: "symbol",
    source: "5ec4d27c8c861c736024026f",
    "source-layer": "LandmarkPoint",
    filter: ["all", ["==", "sub_type_code", 1102], ["==", "sub_group", 0]],
    layout: {
      "icon-anchor": "center",
      "icon-image": {
        stops: [
          [15, "hospital-11"],
          [20, "hospital-15"],
        ],
      },
      "icon-offset": [0, -12],
      "icon-size": {
        stops: [
          [10, 0.5],
          [17, 1],
          [20, 1.5],
        ],
      },
      "text-field": "{name}",
      "text-font": ["Kanit"],
      "text-justify": "center",
      "text-max-width": 10,
      "text-size": {
        stops: [
          [10, 6],
          [15, 9],
          [20, 11],
        ],
      },
      visibility: "visible",
    },
    paint: {
      "icon-opacity": 0.5,
      "text-color": "rgba(86, 81, 81, 0.97)",
      "text-halo-blur": 1,
      "text-halo-color": "rgba(243, 240, 240, 0.98)",
      "text-halo-width": 2,
    },
  },
  {
    id: "Landmark_university",
    type: "symbol",
    source: "5ec4d27c8c861c736024026f",
    "source-layer": "LandmarkPoint",
    filter: ["all", ["==", "sub_type_code", 1101], ["==", "sub_group", 2]],
    layout: {
      "icon-anchor": "center",
      "icon-image": {
        stops: [
          [15, "college-11"],
          [20, "college-15"],
        ],
      },
      "icon-offset": [0, -10],
      "icon-size": {
        stops: [
          [10, 0.5],
          [17, 1],
          [20, 1.5],
        ],
      },
      "text-field": "{name}",
      "text-font": ["Kanit"],
      "text-justify": "center",
      "text-size": {
        stops: [
          [10, 6],
          [15, 9],
          [20, 11],
        ],
      },
      visibility: "visible",
    },
    paint: {
      "icon-opacity": 0.5,
      "text-color": "rgba(86, 81, 81, 0.97)",
      "text-halo-blur": 1,
      "text-halo-color": "rgba(243, 240, 240, 0.98)",
      "text-halo-width": 2,
    },
  },
  {
    id: "Landmark_school",
    type: "symbol",
    source: "5ec4d27c8c861c736024026f",
    "source-layer": "LandmarkPoint",
    filter: ["all", ["==", "sub_type_code", 1101], ["==", "sub_group", 1]],
    layout: {
      "icon-anchor": "center",
      "icon-image": "school",
      "icon-offset": [0, -70],
      "icon-size": {
        stops: [
          [10, 0.1],
          [17, 0.12],
          [20, 0.2],
        ],
      },
      "text-field": "{name}",
      "text-font": ["Kanit"],
      "text-justify": "center",
      "text-max-width": 50,
      "text-size": {
        stops: [
          [10, 6],
          [15, 9],
          [20, 11],
        ],
      },
      visibility: "visible",
    },
    paint: {
      "icon-opacity": 0.5,
      "text-color": "rgba(86, 81, 81, 0.97)",
      "text-halo-blur": 1,
      "text-halo-color": "rgba(243, 240, 240, 0.98)",
      "text-halo-width": 2,
    },
  },
  {
    id: "Landmark_education",
    type: "symbol",
    source: "5ec4d27c8c861c736024026f",
    "source-layer": "LandmarkPoint",
    filter: ["all", ["==", "sub_type_code", 1101], ["==", "sub_group", 0]],
    layout: {
      "icon-anchor": "center",
      "icon-image": {
        stops: [
          [15, "school-11"],
          [20, "school-15"],
        ],
      },
      "icon-offset": [0, -10],
      "icon-size": {
        stops: [
          [10, 0.5],
          [17, 1],
          [20, 1.5],
        ],
      },
      "text-field": "{name}",
      "text-font": ["Kanit"],
      "text-justify": "center",
      "text-size": {
        stops: [
          [10, 6],
          [15, 9],
          [20, 11],
        ],
      },
      visibility: "visible",
    },
    paint: {
      "icon-opacity": 0.5,
      "text-color": "rgba(86, 81, 81, 0.97)",
      "text-halo-blur": 1,
      "text-halo-color": "rgba(243, 240, 240, 0.98)",
      "text-halo-width": 2,
    },
  },
  {
    id: "Building_text",
    type: "symbol",
    source: "5ec4d27c8c861c736024026f",
    "source-layer": "Building",
    minzoom: 17,
    layout: {
      "symbol-placement": "point",
      "symbol-spacing": 20,
      "text-field": "{house_no}",
      "text-font": ["Kanit", "Kanit"],
      "text-size": {
        stops: [
          [15, 6],
          [17, 7],
          [22, 11],
        ],
      },
      visibility: "visible",
    },
    paint: {
      "text-color": "rgba(43, 40, 40, 1)",
      "text-halo-blur": 1,
      "text-halo-color": "rgba(255, 255, 255, 1)",
      "text-halo-width": 2,
    },
  },
];
